<template>
    <div style="background-color:#fff;line-height: 0;">
        <div class="stock" v-if="purchased == 1">


            <!-- 新智能诊股内容 -->
            <div class="phone_znzg" aria-label="智能诊股行情逻辑" v-if="has_ai_report">
                
                <div class="overview overview_k">

                    <div class="overview_kh">
                        <div class="overview_kh1">
                            <span>{{ name }}</span>
                            <span v-if="stock_data" :class="[stock_data.chg_pct>0 ? 'red' : 'green']">{{ stock_data.price }}</span>

                        </div>
                        <div class="overview_kh2">
                            <span >{{ code }}</span>
                            <span v-if="stock_data" :class="[stock_data.chg_pct>0 ? 'red' : 'green']">{{ stock_data.chg }} {{ stock_data.chg_pct }}%</span>
                        </div>
                    </div>


                    <!-- 切换按钮 -->
                    <div class="chart-tabs">
                        <button
                            :class="['tab-btn', { active: chartType === 'time' }]"
                            @click="switchChart('time')"
                        >
                            分时
                        </button>
                        <button
                            :class="['tab-btn', { active: chartType === 'daily' }]"
                            @click="switchChart('daily')"
                        >
                            日K
                        </button>
                        <button
                            :class="['tab-btn', { active: chartType === 'weekly' }]"
                            @click="switchChart('weekly')"
                        >
                            周K
                        </button>
                        <button
                            :class="['tab-btn', { active: chartType === 'monthly' }]"
                            @click="switchChart('monthly')"
                        >
                            月K
                        </button>
                    </div>

                    <div class="chart-wrapper">
                        <img v-if="loading" class="loading-overlay" src="https://img.aigupiao.com/www/20151121/loading.gif" />


                        <div class="overview_chart" v-if="chartType != 'time'">
                            <!-- k线 -->
                            <div @click="openstock()" v-if="stockData">
                                <KLine :stockData="stockData" />
                            </div>

                        </div>

                        <div class="overview_chart"  v-if="chartType === 'time'">
                            <!-- 分时 -->
                            <div @click="openstock()" v-if="timeData">

                                <fst 
                                    :timeData="timeData" 
                                    :code="code"
                                    :autoRefresh="true"
                                    :refreshInterval="60000"
                                    @refresh="handleRefresh"
                                    :stock_data="stock_data"
                                
                                />
                            </div>
                        </div>

                    </div>


                </div>

                
                <section class="section-stack">
                

                    <!-- 行情概述 -->
                    <article id="overview" class="overview" v-if="overviewContent">
                    <h2>行情概述</h2>
                    <p v-html="overviewContent"></p>
                    </article>


                    <!-- 主要章节 -->
                    <section id="logicList" class="section-stack">
                        <details
                        v-for="(section, index) in sections"
                        :key="index"
                        class="logic-card"
                        open=""
                        >
                        <summary aria-expanded="true">
                            <span class="icon" aria-hidden="true">
                            <img :src="section.icon" alt="">
                            </span>
                            <h3 class="summary-title">{{ section.title }}</h3>
                            <span class="chevron" aria-hidden="true"></span>
                        </summary>
                        <div class="logic-body" style="height: auto; opacity: 1;">
                            <!-- 引导语：遍历数组，每个段落一个 <p> -->
                                <p 
                                    v-for="(paragraph, idx) in section.intro" 
                                    :key="paragraph"
                                    class="section-intro"
                                    v-html="paragraph"
                                    ></p>
                            <p
                            v-for="(item, idx) in section.items"
                            :key="idx"
                            class="numbered-item"
                            >
                            <span class="item-marker">{{ idx + 1 }}.</span>
                            <span class="item-copy" v-html="item"></span>
                            </p>
                        </div>
                        </details>
                    </section>

                    <!-- 风险提醒独立模块 - 使用 article 结构 -->
                    <article v-if="riskSection" id="riskCard" class="risk-card"
                    :class="{ open: isRiskOpen }"
                    
                    >
                    <button
                        id="riskToggle"
                        class="risk-head"
                        type="button"
                        aria-expanded="true"
                        aria-controls="riskList"
                        @click="toggleRisk"
                    >
                        <span class="icon" aria-hidden="true">
                        <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-risk.svg" alt="">
                        </span>
                        <h3>{{ riskSection.title }}</h3>
                        <span class="chevron" aria-hidden="true"></span>
                    </button>
                    <div id="riskList" class="risk-list" :style="riskListStyle">
                        <div
                        v-for="(item, idx) in riskSection.items"
                        :key="idx"
                        >
                        <p class="risk-item" v-html="item"></p>
                        <span
                            v-if="idx < riskSection.items.length - 1"
                            class="risk-divider"
                            aria-hidden="true"
                        ></span>
                        </div>
                    </div>
                    </article>




                </section>
            </div>



            <div class="data_update" v-if="!has_ai_report">
                <span>数据更新</span>&nbsp;&nbsp;<span>{{update_time}}</span>
            </div>
            <div class="company_box" v-if="!has_ai_report">
                <div class="grade_box">
                    <div class="company_chart">
                        <company_chart
                                :quality="Math.ceil(overview.quality_score)"
                                :institution="Math.ceil(overview.institution_score)"
                                :industry="Math.ceil(overview.industry_score)"
                                :valuation="Math.ceil(overview.valuation_score)"
                                :trend="Math.ceil(overview.trend_score)"
                        />
                    </div>
                    <div class="grade">
                        <div class="grade_name">综合评分</div>
                        <div class="grade_number">{{Math.ceil(overview.total_score)}}</div>
                        <div class="grade_word">击败了<span>{{Math.ceil(overview.beat_percent*100)}}%</span>的个股</div>
                    </div>
                </div>
                <div class="company_quality">
                    <div class="company_quality_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/gs2.png"/>
                        <span class="big_title_common">公司质地</span>
                    </div>
                    <div class="company_quality_content">
                        <ul v-if="quality.msgs">
                            <li v-for="item in quality.msgs">
                                <div class="point"></div>
                                <p>
                                    <span v-for="i in item":class="{ 'point_tag': i.mark  }" >{{i.str}}</span>
                                </p>
                            </li>
                        </ul>
                        <ul v-if="!quality.msgs">
                            <li>
                                <div class="point"></div>
                                <p>
                                    暂无公司质地
                                </p>
                            </li>
                        </ul>
                        <div class="company_tag" v-if="quality.tags">{{quality.tags}}</div>
                    </div>
                </div>
                <div class="company_quality">
                    <div class="company_quality_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/dq2.png"/>
                        <span class="big_title_common">短期策略</span>
                    </div>
                    <div class="company_quality_content">
                        <ul v-if="strategy.msgs">
                            <li v-for="item in strategy.msgs">
                                <div class="point blue"></div>
                                <p>
                                    <span v-for="i in item">{{i.str}}</span>
                                </p>
                            </li>
                        </ul>
                        <ul v-if="!strategy.msgs">
                            <li>
                                <div class="point blue"></div>
                                <p>
                                    暂无短期策略
                                </p>
                            </li>
                        </ul>
                        <div class="company_tag tag_blue" v-if="strategy.tags">{{strategy.tags}}</div>
                    </div>
                </div>
            </div>


            <div class="data_box" v-if="!has_ai_report && znzg_in">
                <div class="data_box_title"><span class="big_title_common big_title_margin">行业题材</span></div>
                <div class="target_price_p" v-if="industryInfo.length > 0">
                    <h1>行业<span>取自申万一级行业和二级行业</span></h1>

                    <div class="plate_wrap">
                        <div class="plate_i" :class="[item.chg > 0 ?'red':'',item.chg < 0 ?'green':'']" v-for="item in industryInfo">
                            <h1>{{item.industryName}}</h1>
                            <span>{{parseF(item.chg)}}%</span>
                        </div>
                    </div>

                </div>
                <div class="target_price_p"  v-if="changeAreaTheme.length > 0">
                    <h1>题材<span>取最相关和有异动的题材</span></h1>

                    <div class="plate_wrap">
                        <div class="plate_i" :class="[item.chgPct > 0 ?'red':'',item.chgPct < 0 ?'green':'']" v-for="item in changeAreaTheme">
                            <i v-if="item.tag">{{item.tag}}</i>
                            <h1>{{item.themeName}}</h1>
                            <span>{{parseF(item.chgPct) }}%</span>
                        </div>
                    </div>
                </div>
                <div class="target_price_p2">
                    <p v-html="industryComment.replace(/<\d{6}>/g,'')"></p>
                    <p v-if="themeComment">
                        <span class="red">异动</span>
                        <span v-html="themeComment.replace(/<\d{6}>/g,'')"></span>
                    </p>
                </div>

            </div>

            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">财务点评</span></div>
                <div class="goodness">
                    <div class="goodness_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/smile.png">
                        <span>财务亮点</span>
                    </div>
                    <div class="goodness_content">
                        <ul v-if="finance_comment.highlight">
                            <li v-for="item in highlight"><div class="goodness_point goodness_content_blue"></div>{{item}}</li>
                        </ul>
                        <ul v-if="!finance_comment.highlight">
                            <li><div class="goodness_point goodness_content_blue"></div>暂无财务亮点</li>
                        </ul>
                    </div>
                </div>
                <div class="goodness">
                    <div class="goodness_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/cry.png">
                        <span class="goodness_title_blue">风险提示</span>
                    </div>
                    <div class="goodness_content">
                        <ul v-if="finance_comment.risk">
                            <li v-for="item in risk"><div class="goodness_point goodness_content_blue"></div>{{item}}</li>
                        </ul>
                        <ul v-if="!finance_comment.risk">
                            <li><div class="goodness_point goodness_content_blue"></div>暂无风险提示</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">机构目标价</span></div>
                <div class="target_price">
                    <div class="target_price_content" v-if="insTargetPrice.comment_list ">
                        <span v-for="item in insTargetPrice.comment_list" :class="{'span_tag' : item.mark}">{{item.str}}</span>
                    </div>
                    <div class="target_price_content target_price_content_none" v-if="!insTargetPrice.comment_list ">
                        <span>暂无机构目标价</span>
                    </div>
                    <div class="target_price_chart" ref="chart" v-if="insTargetPrice.comment_list ">
                        <div class="target_price_chart_box" style="top: 0;" v-if="insTargetPrice.pct && insTargetPrice.avg - insTargetPrice.max != 0">
                            <div>最高目标价</div><div>{{insTargetPrice.max}}元</div>
                        </div>
                        <div class="target_price_chart_box" :style="{ bottom : min_bottom }" v-if="insTargetPrice.pct && insTargetPrice.avg - insTargetPrice.min !=0">
                            <div>最低目标价</div><div>{{insTargetPrice.min}}元</div>
                        </div>
                        <div :class="['target_price_chart_box',!insTargetPrice.pct ? 'target_price_chart_box_blue':'target_price_chart_box_red']"
                             :style="{top : avg_top }">
                            <div>目标均价</div><div :class="[!insTargetPrice.pct ? 'target_font_blue':'target_font_red']">{{insTargetPrice.avg}}元</div>
                        </div>
                        <div :class="['target_price_chart_box',!insTargetPrice.pct ? 'target_price_chart_box_red':'target_price_chart_box_blue']"
                             :style="{top : cur_top  }">
                            <div>当前价</div><div :class="[!insTargetPrice.pct ? 'target_font_red':'target_font_blue']">{{insTargetPrice.cur}}元</div>
                        </div>
                        <div class="target_price_chart_squre" ref="chartsqure" v-if="insTargetPrice.pct"
                             :style="{top : squre_top , height : squre_height}"
                        >
                            <div class="target_price_chart_squre_text">目标涨幅{{insTargetPrice.pct}}</div>
                            <div class="target_price_chart_squre_tag">
                                <div></div><div></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="data_box">
                <div class="data_box_title"><span class="big_title_common big_title_margin">机构持股比例</span></div>
                <div class="target_price">
                    <div class="target_price_content" v-if="insHoldRatio.hs">
                        <span v-for="item in insHoldRatio.hs" :class="{'span_tag' : item.mark}">{{item.str}}</span>
                    </div>
                    <div class="target_price_content target_price_content_none" v-if="!insHoldRatio.hs">
                        暂无机构持股比例
                    </div>
                    <div class="ratio_chart" v-if="insHoldRatio.hs">
                        <RatioChart :price="insHoldRatio.price" :ratio="insHoldRatio.ratio" />
                    </div>
                </div>
            </div>
            <div class="data_box">
                <div class="data_box_title"><span class="big_title_common big_title_margin">机构评级</span></div>
                <div class="target_price" v-if="insGradeResult.grade > 0">
                    <div class="target_price_content">{{insGradeResult.comment}}</div>
                    <div class="target_price_content_chart">
                        <div class="target_price_content_chart_pos_box">
                            <div class="target_price_content_chart_pos" :style="{left:price_left+'%' }"></div>
                        </div>
                        <div class="target_price_content_chart_wrap">
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color"></div>
                                <div class="target_price_content_chart_box_word">卖出</div>
                            </div>
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color color2"></div>
                                <div class="target_price_content_chart_box_word">减持</div>
                            </div>
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color color3"></div>
                                <div class="target_price_content_chart_box_word">中性</div>
                            </div>
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color color4"></div>
                                <div class="target_price_content_chart_box_word">增持</div>
                            </div>
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color color5"></div>
                                <div class="target_price_content_chart_box_word">买入</div>
                            </div>
                        </div>
                    </div>
                    <div class="grade_table">
                        <div class="grade_table_title">
                            <span>名称</span>
                            <span>日期</span>
                            <span>评级</span>
                        </div>
                        <ul>
                            <li v-for="item in insGradeResult.item_list">
                                <span>{{item.name}}</span>
                                <span>{{item.date}}</span>
                                <span :class="[item.content == '买入' ? 'grade_red': (item.content == '增持' ? 'grade_yellow' : 'grade_green' )]">{{item.content}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="target_price" v-if="insGradeResult.grade == 0">
                    <div class="target_price_content target_price_content_none">暂无机构评级</div>
                </div>
            </div>
            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">主力资金</span></div>
                <div class="target_price" v-if="moneyGraph.hs">
                    <div class="target_price_content">{{moneyGraph.hs}}</div>
                    <mainCapital
                            :xl="parseInt(mainCapital1.xl)"
                            :l="parseInt(mainCapital1.l)"
                            :m="parseInt(mainCapital1.m)"
                            :s="parseInt(mainCapital1.s)"
                    >

                    </mainCapital>
                </div>
                <div class="target_price" v-if="!moneyGraph.hs">
                    <div class="target_price_content target_price_content_none">暂无主力资金</div>
                </div>
            </div>
            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">技术分析</span></div>
                <div class="target_price">
                    <div class="target_price_content" v-if="techAspect.aspect_comment">{{techAspect.aspect_comment}}</div>
                    <div :class="[!techAspect.aspect_comment && !techAspect.k_node_list ? 'target_price_content_none':'' ,'target_price_content']" v-if="!techAspect.aspect_comment">暂无技术分析</div>
                <div class="technical_analysis" v-if="techAspect.k_node_list">
                    <div class="technical_analysis_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/tri.png"/>
                        压力与支撑</div>
                    <div class="technical_analysis_chart">
                        <Kchart :k_node_list="techAspect.k_node_list" />
                    </div>
                </div>
                <div class="technical_analysis" v-if="0 && techAspect.signals">
                    <div class="technical_analysis_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/tri.png"/>
                        当前技术信号/形态
                    </div>
                    <div class="technical_analysis_box">
                        <span v-for="item in techAspect.signals" :class="[item.type == 'SHORT' ? 'down_span':(item.type == 'HOLD' ? 'down_span':'hold_span')]">
                            {{item.name}}
                        </span>
                    </div>
                </div>
                </div>
            </div>
            <div class="data_box">
                <div class="data_box_title"><span class="big_title_common big_title_margin">龙虎榜</span></div>
                <div class="target_price">
                    <div class="target_price_content longhu" v-if="dragonTiger.hs != '最近30日未登上龙虎榜'">{{dragonTiger.hs}}</div>
                    <div class="longhu_box" v-if="dragonTiger.hs != '最近30日未登上龙虎榜'">
                        <div class="longhu_range">
                            <div>{{dragonTiger.rank_date}}</div>
                            <div class="longhu_rise" v-if="dragonTiger.chg_pct >= 0">
                                <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/zhang.png" />
                                <span>涨幅：</span>
                                <span class="longhu_rise_red">+{{(dragonTiger.chg_pct*100).toFixed(2)}}%</span>
                            </div>
                            <div class="longhu_rise longhu_fall" v-if="dragonTiger.chg_pct < 0">
                                <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/die.png" />
                                <span>跌幅：</span>
                                <span class="longhu_rise_green">{{(dragonTiger.chg_pct*100).toFixed(2)}}%</span>
                            </div>
                        </div>
                        <div class="longhu_total">
                            <div><p>买入(万元)</p><p class="total_num total_num_buy">{{(dragonTiger.total_buy/10000).toFixed(2)}}</p></div>
                            <div><p>卖出(万元)</p><p class="total_num total_num_sell">{{(dragonTiger.total_sell/10000).toFixed(2)}}</p></div>
                            <div><p>净买(万元)</p><p class="total_num total_num_net">{{(dragonTiger.total/10000).toFixed(2)}}</p></div>
                        </div>
                        <div class="longhu_reason">上榜理由：{{dragonTiger.reason}}</div> 
                        <div class="expand" v-show="longhu_expand == 0" @click="expand"><img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/open.png"/>展开</div>
                        <div v-show="longhu_expand == 1">
                            <div class="longhu_table">
                                <div class="longhu_table_title">
                                    <div class="longhu_table_buy5 longhu_red">买入前五</div>
                                    <div>买入(万)</div><div class="longhu_table_sell">卖出(万)</div>
                                </div>
                                <ul>
                                    <li v-for="item in dragonTiger.buy_list">
                                        <div class="longhu_table_buy5">{{item.sales}}</div>
                                        <div class="longhu_red">{{(item.buyValue/10000).toFixed(2)}}</div>
                                        <div class="longhu_table_sell longhu_blue">{{(item.sellValue/10000).toFixed(2)}}</div>
                                    </li>
                                </ul>
                            </div>
                            <div class="longhu_table">
                                <div class="longhu_table_title">
                                    <div class="longhu_table_buy5 longhu_green">卖出前五</div><div>买入(万)</div><div class="longhu_table_sell">卖出(万)</div>
                                </div>
                                <ul>
                                    <li v-for="item in dragonTiger.sell_list">
                                        <div class="longhu_table_buy5">{{item.sales}}</div>
                                        <div class="longhu_red">{{(item.buyValue/10000).toFixed(2)}}</div>
                                        <div class="longhu_table_sell longhu_blue">{{(item.sellValue/10000).toFixed(2)}}</div>
                                    </li>
                                </ul>
                            </div>
                            <div class="expand" v-show="longhu_expand == 1" @click="expand"><img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/close.png"/>收起</div>
                        </div>
                    </div>
                    <div class="target_price_content target_price_content_none " v-if="dragonTiger.hs == '最近30日未登上龙虎榜'">最近30日未登上龙虎榜</div>
                </div>
            </div>


            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">融资融券</span></div>
                <div class="target_price">
                    <div class="target_price_content" v-if="finSecGraph.fin_comment">{{finSecGraph.fin_comment}}</div>
                    <div class="target_price_content target_price_content_none" v-if="!finSecGraph.fin_comment">暂无融资融券</div>
                    <div class="financing_chart" v-if="finSecGraph.fin_comment">
                        <FinancingChart :node_list="finSecGraph.node_list" :sum_list="finSecGraph.sum_list" :name="name" />
                    </div>
                </div>
            </div>




            <div class="risk_statement">
                智能诊断内容基于大数据智能生成，不构成投资建议，风险自担
            </div>
        </div>
        <!-- 未购买 -->
        <div class="not_purchased" v-if="purchased == 0">
            <div class="not_purchased_box">
                <div class="not_name">{{name}}({{symbol}})</div>
                <div class="not_situation">
                    <span></span>&nbsp;&nbsp;&nbsp;<span></span>
                </div>
                <div class="not_trait">
                    <div>
                        <div class="not_trait_img">
                            <img class="img_one" src="https://cdncos.aigupiao.com/assets/wap/img/znzg/dpzd2.png" />
                        </div>
                        <div class="not_trait_word">大数据诊断</div>
                        <div class="not_trait_word">精准解析个股状态</div>
                    </div>
                    <div>
                        <div class="not_trait_img">
                            <img class="img_two" src="https://cdncos.aigupiao.com/assets/wap/img/znzg/rgzn2.png" />
                        </div>
                        <div class="not_trait_word">人工智能技术</div>
                        <div class="not_trait_word">多因子深度诊断</div>
                    </div>
                    <div>
                        <div class="not_trait_img">
                            <img class="img_three" src="https://cdncos.aigupiao.com/assets/wap/img/znzg/jyjy2.png" />
                        </div>
                        <div class="not_trait_word">智能评分系统</div>
                        <div class="not_trait_word">AI系统独有持仓建议</div>
                    </div>
                </div>
                <!--task-->
                <a v-if="!is_from_agq && !is_from_kd && !is_from_zf" :href="'?kind=XNZG&stock_code='+symbol+'#AiGuPiao_ThirdPay'" class="not_btn">
                    查看此诊股 只需30金币
                </a>
                <p v-if="!is_from_agq && !is_from_kd && !is_from_zf">购买后24小时内有效</p>

                <a v-if="is_from_agq" href="javascript:;" class="not_btn">
                    开通任意圈子会员 即可免费使用
                </a>
                <a v-if="is_from_kd" href="javascript:;" class="not_btn">
                    开通任意星球会员 即可免费使用
                </a>
                <a v-if="is_from_zf" href="javascript:;" class="not_btn">
                    开通任意圈子会员 即可免费使用
                </a>

                <p v-if="is_from_agq" class="agq">
                    有疑问请联系
                    <a href="javascript:;" @click="funToApp('srGoToContact',[])">爱股圈小秘书</a>
                </p>
                <p v-if="is_from_kd" class="agq">
                    有疑问请联系
                    <a href="javascript:;" @click="funToApp('srGoToContact',[])">星球小秘书</a>
                </p>
                <p v-if="is_from_zf" class="agq">
                    有疑问请联系
                    <a href="javascript:;" @click="funToApp('srGoToContact',[])">中富通小秘书</a>
                </p>
            </div>
        </div>
        <!-- 暂无诊股 -->
        <div class="none" v-if="purchased == 2">
            <div class="none_img"><img :src="require('@/assets/images/znzg/none.png')"></div>
            <p>暂无此诊股...</p>
        </div>
    </div>

</template>

<script>
import "@/utils/flexible";
import company_chart from './charts/Company_chart.vue'
import RatioChart from './charts/RatioChart.vue'
import Kchart from './charts/Kchart.vue'
import KLine from './charts/KLineWithMA.vue'
import fst from './charts/fst.vue'
import FinancingChart from './charts/FinancingChart.vue'
import MainCapital from './charts/MainCapital.vue'
import Api from "@/api/Intelligent_diagnosis_stock/index";
    import * as echarts from 'echarts'
    export default {
        name: "index",
        components:{
          company_chart,
          RatioChart,
          Kchart,
          KLine,
          fst,
          FinancingChart,
          MainCapital
        },
        data(){
            return{
                user_id:this.$route.params.uid,
                symbol:this.$route.params.id,
                name:decodeURI(this.$route.params.name),
                purchased : 3, //是否为购买，1为是,0为未购买，2是暂无此诊股
                longhu_expand : 0, //是否已经展开龙虎榜
                overview:'',// 综合得分
                quality:'', //公司质地
                strategy:'',// 短期策略
                dragonTiger:'',//龙虎榜
                finSecGraph:'', //融资融券
                moneyGraph:'', //主力资金
                techAspect:'', //技术分析
                insGradeResult:'',//  机构评级
                insHoldRatio:'',//  机构持股比例
                insTargetPrice:'',//机构目标价
                finance_comment:'',//财务点评
                highlight:'',//财务亮点
                risk:'',//风险提示
                update_time:'',//更新时间
                avg_top :0,
                cur_top :0,
                avg_bottom :0,
                min_bottom :0,
                squre_height:0,
                squre_top:0,
                mainCapital1:{},//主力资金
                price_left:0,

                is_from_agq:false,//来自爱股圈
                is_from_kd: false, // 来自科德
                is_from_zf: false, // 来自中福

                znzg_in :false,
                changeAreaTheme:[],
                industryInfo:[],
                industryComment:'',
                themeComment:'',


                sections: [],
                riskSection: null,
                overviewContent:'',
                has_ai_report:true,//存在ai报告
                isRiskOpen: true, // 默认展开

                stock_data:null,//股票当前数据
                stockData:null,//k线图
                timeData:null,

                chartType: 'daily',     // 'time' 或 'kline'
                loading: false,
                code:'',//后端返回完整股票代码
            }

        },
        created() {
            this.is_from_agq = location.href.includes('is_from_agq');
            this.is_from_kd = location.href.includes('is_from_kd');
            this.is_from_zf = location.href.includes("is_from_zf");
        },
        mounted(){


            

            let data = {user_id:this.user_id, symbol:this.symbol};
            if(this.is_from_agq){
                data.is_from_agq = 'yes';
            }
            if(this.is_from_kd) {
                data.is_from_kd = 'yes'
            }
            if(this.is_from_zf) {
                data.is_from_zf = "yes";
            }

            
            this.stockDetail(data);


            //todo 开发调试时注释

            // let data2 ={
            //         ai_report:{
            //         "content": "# 华润双鹤（600062）近期震荡分化 政策与新业务预期主导盘面（截至2026年7月15日）\n华润双鹤近期整体呈现窄幅震荡、多空力量分歧的运行特征，7月以来单日涨跌幅均未超过1%，7月14日收盘涨幅为0.96%，对应成交额1.57亿元。**核心驱动来自《国民健康“十五五”规划》对创新药、合成生物赛道的政策利好催化**，而压制因素主要源于一季度营收阶段性下滑带来的基本面扰动，当前资金整体呈现阶段性流出态势，盘面交易主线围绕政策红利与新业务落地预期展开。\n\n## 一、政策催化：行业顶层规划匹配公司转型方向（短期情绪支撑）\n2026年7月发布的《国民健康“十五五”规划》提出全链条支持创新药、核酸药物、合成生物制造等领域发展，多项政策方向与华润双鹤现有业务布局高度契合。\n- 政策明确优化siRNA小核酸药物、罕见病药优先审评通道，公司DC6001等中美双报创新品种有望缩短上市周期，加快后续医保落地节奏。\n- 规划重点扶持儿童用药、生物制造产业，公司现有巯嘌呤微片等儿科制剂可巩固细分赛道优势，在建合成生物项目可享受专项补贴与税收优惠，市场对其新业务落地进度的关注度明显提升。\n\n## 二、基本面现状：一季度营收阶段性下滑，核心业务保持稳健\n据公司2026年4月披露的一季度经营数据公告，当期主营业务合计营收27.89亿元，同比下滑8.62%，整体毛利率为59.00%，同比小幅下降1.46个百分点。\n- 分板块来看，输液业务营收同比下滑15.01%，非输液业务营收同比下滑6.47%，但两大板块毛利率均保持在55%以上，盈利韧性未出现明显弱化。\n- 公司2026年3月披露的电商体系建设进展显示，全国异地分仓48小时到货率提升至57%-73%，北京地区180家医疗单位实现24小时配送，OTC渠道覆盖能力持续优化。\n\n## 三、新业务进展：合成生物板块逐步落地，市场预期持续升温\n据2026年6月公司披露的投资者关系活动记录表，合成生物板块已实现阶段性技术突破，成为市场重要交易主线。\n- 目前14-丁二胺已达成百吨级量产，计划2026年12月底落地千吨级产能，后续可根据下游订单快速扩产至万吨级别，与沃特股份合作的生物基PA46材料可应用于新能源汽车零部件领域。\n- 公司已打通从基因编辑、菌种筛选到规模化发酵的全链条技术平台，行业普遍存在的中试放大“死亡之谷”问题已得到针对性解决，后续中试新产品预计2026年底至2027年初陆续投放市场。\n\n## 四、资金面：阶段性资金流出，筹码整体呈分散态势\n截至2026年7月14日数据，近期资金整体呈现小幅流出特征，未出现明显的单边加仓或减仓信号。\n- 近5个交易日主力资金累计净流出1166.36万元，近20个交易日累计净流出1.09亿元，7月14日当日主力资金净流入118.25万元，短期流出节奏有所放缓。\n- 当前市场平均筹码成本为18.30元，主力持仓占比仅4.27%，筹码分布较为分散，当前股价靠近17.17元压力位，尚未形成明确的突破趋势。\n\n## 风险提示\n- 2026年一季度公司输液、非输液板块营收均出现同比下滑，若下半年终端需求恢复不及预期，存在业绩继续承压的可能。\n- 合成生物新业务中试产品落地进度、下游客户拓展情况仍存在不确定性，相关产能释放后的盈利贡献尚未经过验证。\n- 公司烟酰胺原料药收入占总营收比例不足0.1%，未开展NMN相关业务，市场对相关热点概念的炒作存在预期透支风险。\n- 医药行业带量采购、医保谈判政策持续推进，公司核心仿制药品种存在降价压力，可能对后续毛利率造成扰动。\n\n信息仅供参考，不构成投资建议。",
            //         "model": "doubaoseed2.0-lite",
            //         "report_date": "2026-07-15",
            //         "update_at": "2026-07-15 14:31:43"
            //     },
            //     ai_report:{
            //     "content": "# 皖维高新（600063）6-7月区间异动：两次涨停后多空博弈加剧（截至2026年7月15日）\n皖维高新在2026年6月上旬至7月初走出两轮涨停行情，先后在6月5日、7月1日触及涨停，核心驱动来自**高端新材料扩产+定增方案优化**的长期成长逻辑，叠加一季报盈利韧性支撑。7月上旬后股价进入多空博弈阶段，围绕定增定价机制调整形成明显分歧，资金层面北向资金、机构席位与短线资金交互博弈，是当前化工新材料板块中兼具业绩确定性和事件催化的标的。\n\n## 一、两轮涨停核心催化：定增投向高端产能，彰显长期成长逻辑\n公司30亿元定增方案全部投向20万吨/年乙烯法功能性PVA树脂、年产3000万平方米高世代面板PVA光学膜项目，直接瞄准国内高端PVA材料进口替代赛道，契合产业链自主可控政策方向。\n- 控股股东全额现金认购且锁定期设置为3年，既保障募投资金足额落地，也向市场传递出对公司长期发展的明确信心，打消了此前市场对定增资金来源的疑虑。\n- 业务端持续聚焦核心主业，吸收合并皖维皕盛完成PVB产业链整合，年降本超3000万元，同步剥离非主业小贷股权回笼资金，主业集中度进一步提升。\n\n## 二、业绩基本面支撑：盈利端保持韧性，机构预测增速明确\n2025年公司归母净利润达4.34亿元，同比增长17.39%；2026年一季度实现营业收入19.45亿元，归母净利润1.36亿元，同比增长15.68%，在营收小幅波动的背景下盈利端展现较强韧性。\n- 近6个月共有8家机构发布相关研报，对公司2026年净利润预测均值达7.62亿元，同比增速预期超75%，其中4家给予“买入”评级，机构整体对其全年盈利表现偏乐观。\n- 作为全球PVA行业龙头，公司在国内PVA产能占比处于领先水平，后续功能性PVA、光学膜产能落地后，产品结构升级将进一步推高盈利中枢。\n\n## 三、资金面博弈：北向与游资合力拉涨，融资盘同步加仓\n6月5日皖维高新因日涨幅偏离值达10.78%登上沪市龙虎榜，当日资金交易活跃度显著提升，是两轮涨停行情的直接推手。\n- 当日全市场成交额达24.63亿元，换手率14.85%，龙虎榜席位合计净买入8816.30万元，其中沪股通专用席位净买入3569.89万元，高盛、华鑫证券上海席位等机构及游资席位同步大额买入。\n- 当日主力资金净流入3.07亿元，近5日主力资金累计净流入1.59亿元；融资余额较前5日增加1.13亿元，增幅达16.93%，融资盘同步加仓放大了股价弹性。7月1日第二次涨停时，单日成交额也达到13.92亿元，资金承接力度较强。\n\n## 四、多空分歧导火索：定增定价机制调整引发博弈\n2026年6月30日公司发布定增预案修订公告，将原固定底价发行规则调整为按发行前20个交易日市价的8折定价，这一规则变动直接成为7月上旬多空博弈的核心焦点。\n- 部分市场观点认为，定增定价调整窗口期存在刻意压低20日均价的交易动机，叠加同期板块整体平稳、个股逆势波动，引发资金分歧。\n- 该修订后的定增方案仍需上交所审核通过及证监会注册，后续定价基准日的明确将直接影响股价短期波动方向，是市场当前重点关注的节点。\n\n## 风险提示\n- 定增项目尚需上交所审核及证监会注册，存在审批进度不及预期或发行失败的风险，高端PVA光学膜项目后续产能释放节奏仍待验证。\n- PVA行业产能投放、原材料价格波动可能导致产品毛利率下行，直接影响全年盈利兑现情况，与机构预测的高增速存在偏差。\n- 7月上旬股价异动已引发市场对定增窗口期交易行为的高度关注，后续若出现异常波动可能触发交易所问询，带来短期情绪冲击。\n- 前期融资盘加仓幅度较高，若后续股价走弱，可能引发融资盘集中平仓，放大短期调整幅度。\n\n信息仅供参考，不构成投资建议。",
            //     "model": "doubaoseed2.0-lite",
            //     "report_date": "2026-07-15",
            //     "update_at": "2026-07-15 14:32:24"
            //     },
            //     ai_report:{
            //     "content": "# 国投资本（600061）近期震荡分化 业绩支撑下的估值修复进程（截至2026年7月15日）\n截至2026年7月14日收盘，国投资本报收6.52元，当日微涨0.62%，近期整体呈现**窄幅震荡、业绩与政策预期交织**的走势，市场交易主线围绕旗下金融子公司盈利超预期、证券行业政策催化展开，同时叠加股份回购的市值管理托底动作。公司股价未出现单边大幅涨跌，多空双方围绕内在价值回归节奏存在分歧。\n\n## 一、核心基本面支撑：子公司信托业绩高增验证盈利韧性\n国投资本旗下核心金融子公司国投泰康信托披露的2026年半年度未经审计财报显示，上半年实现净利润297,360.54万元，同比增长33.44%，营业总收入同比增长28.85%。该数据大幅跑赢行业平均增速，成为近期支撑公司估值的核心基本面锚点。\n公司2025年全年归母净利润32.79亿元，同比增长21.71%；2026年第一季度归母净利润7.66亿元，同比增长12.63%，连续两个报告期保持双位数正增长，经营质量保持稳健。国投资本在7月8日互动平台明确表示，当前二级市场表现未能充分反映公司实际经营业绩与资产质量，向市场传递了对自身基本面的信心。\n\n## 二、市值管理托底：累计超4亿元回购夯实股价安全垫\n公司已连续实施两轮股份回购，累计回购金额超过4亿元，是近期托底股价的重要支撑力量。大额回购动作向市场传递了管理层对公司长期内在价值的认可，在震荡市中降低了股价大幅下行的弹性。\n当前公司发行的可转换公司债券仍处于转股期，后续相关安排公司将以公告形式正式披露，市场预期后续股本结构优化动作有望进一步配合市值管理目标推进。\n\n## 三、行业政策催化：资本市场改革预期带动非银板块情绪\n2026年6月下旬，资本市场投资端改革相关政策预期持续升温，中信证券等头部券商研报指出，《资本市场投资端改革行动方案》或将出台，同时券商风控指标优化、行业并购重组支持政策同步推进，证券行业迎来历史性发展机遇。国投资本作为涵盖证券、信托、基金等多牌照的国有金融控股平台，直接受益于非银金融板块的政策红利扩散。\n市场预期中长期资金入市比例提升、交易端活跃度改善，将直接带动公司旗下经纪、资管、信托等多线业务的盈利弹性释放，成为当前资金交易的重要预期主线。\n\n## 四、资金面格局：存量博弈下主力资金短期净流出\n截至2026年7月14日收盘，国投资本全天成交额1.98亿元，换手率0.48%，当日主力资金净流出1701.84万元，游资资金净流入350.38万元，散户资金净流入1351.46万元。当前整体交投活跃度处于偏低水平，存量博弈特征明显，尚未出现增量资金大规模进场推动股价趋势性上涨的信号。\n近期股价窄幅波动区间未突破前期震荡平台，资金分歧主要来源于短期业绩兑现节奏与长期估值修复空间的定价差异。\n\n## 风险提示\n1.  旗下国投瑞银基金此前推出的国投白银LOF投资者补偿方案，预计对2026年度归母净利润产生一定负面影响，影响上限约1.35亿元，后续实际计提金额仍存在不确定性。\n2.  证券行业政策落地节奏不及预期，若市场交易量持续维持低位，将直接拖累公司旗下证券、资管板块的盈利表现。\n3.  当前公司股价震荡格局未有效打破，主力资金连续短期净流出，后续若缺乏增量资金接力，估值修复进程可能慢于市场预期。\n4.  可转债转股后续进展存在不确定性，可能对二级市场股份供需结构带来阶段性扰动。\n\n信息仅供参考，不构成投资建议。",
            //     "model": "doubaoseed2.0-lite",
            //     "report_date": "2026-07-15",
            //     "update_at": "2026-07-15 14:31:08"
            //     },

            //     ai_report:{
            //     "content": "# 浦发银行（600000）近期震荡分化 6月创60日新低（截至2026年7月15日）\n浦发银行近期整体呈现**震荡分化、多空力量相对均衡**的走势，6月29日盘中创下8.63元的60日新低后股价逐步修复，截至7月中旬股价围绕9元一线波动。基本面端一季度营收、净利润小幅双增，支撑估值底；资金面则呈现主力资金阶段性流出、融资资金小幅加仓的分歧格局，当前交易主线围绕银行板块资产质量修复与高股息分红展开。\n\n## 一、走势复盘：60日新低后窄幅震荡，多空博弈收敛\n- 6月29日盘中股价下探8.63元，创下近60个交易日新低，当日跌幅1.48%，短期抛压集中释放。\n- 新低之后股价未继续大幅下挫，逐步回升至9元附近震荡，近20个交易日主力资金成本约8.97元，当前价格贴近机构持仓成本线。\n- 技术面指标暂无明确趋势性信号，短期市场关注意愿保持中性，未出现极端放量或缩量的异动特征。\n\n## 二、基本面支撑：一季报营收净利双增，资产质量持续向好\n- 据2026年一季报披露，报告期内集团实现营业收入465.73亿元，同比增长1.42%；归母净利润178.61亿元，同比增长1.49%，实现稳健开局。\n- 资产负债结构持续优化，报告期末存款总额较上年末增长3.52%，活期存款占比较上年末提升1.97个百分点，利息净收入同比增长12.43%，负债端成本管控成效显现。\n- 资产质量保持“双降”态势，不良贷款率1.23%，较上年末下降0.03个百分点；拨备覆盖率204.79%，较上年末上升4.07个百分点，风险缓冲垫进一步增厚。\n\n## 三、资金面分歧：主力阶段性流出，融资资金逆势加仓\n- 据证券之星披露，6月29日前10个交易日内，主力资金累计净流出4757.25万元，短期机构资金呈现阶段性兑现动作，是股价创下60日新低的直接推手之一。\n- 同期融资余额累计增加6513.27万元，融资资金呈现逆势布局态势；截至7月13日，公司融资融券差额为37.76亿元，占流通盘比例1.23%，较前一交易日略有上升。\n- 据东方财富网数据，当前机构参与度为39.77%，属于中度控盘区间，主力资金尚未出现大幅集中流入或流出的极端信号，资金整体处于观望状态。\n\n## 四、近期事件催化：2025年度权益分派落地，高股息属性强化\n- 据7月10日公司发布的2025年年度权益分派实施公告，年度分红方案进入落地执行阶段，持续兑现银行板块高股息属性，对长期配置资金形成一定吸引力。\n- 公司科技金融贷款余额保持1万亿元以上，绿色信贷余额达7383.57亿元，普惠两增贷款规模5367.28亿元，持续契合国家政策导向，市场对其长期业务结构优化形成稳定预期。\n\n## 风险提示\n银行板块整体息差仍面临行业性收窄压力，可能对后续利息净收入增速形成约束。宏观经济复苏节奏若不及预期，可能导致部分区域信贷资产质量出现波动。近期主力资金未呈现明确持续流入态势，股价短期向上弹性或相对有限。行业板块整体估值修复行情若出现回调，个股或随板块同步波动。\n\n信息仅供参考，不构成投资建议。",
            //     "model": "doubaoseed2.0-lite",
            //     "report_date": "2026-07-15",
            //     "update_at": "2026-07-15 14:05:32"
            //     },

            //     ai_report:{
            //     "content": "# 万东医疗（600055）震荡反弹 回购与板块共振下的行情解读（截至2026年7月15日）\n万东医疗近期呈现**板块贝塔行情带动下的震荡反弹走势**，7月初受股份回购落地催化出现阶段性跟涨，7月中旬随半年度业绩预告披露进入多空博弈阶段。当前核心交易主线围绕回购价值支撑、影像设备行业政策修复预期与海外业务高增三条逻辑展开，同时业绩短期承压带来一定估值压制。\n\n## 一、直接催化：近6000万元股份回购落地，传递价值认可信号（行情支撑底）\n据公司2026年7月1日披露的回购实施结果公告，截至6月30日公司已累计完成回购金额5998.98万元，接近此前计划回购金额上限。\n- 本次回购股份用途为后续股权激励或员工持股计划，管理层以真金白银向市场传递对公司长期价值的认可，对短期股价形成直接托底支撑。\n- 从市场反馈来看，7月1日当日股价随医疗器械设备板块同步上行，成为行情启动的直接触发因素之一，资金对回购落地的正向解读短期推升了个股交易热度。\n\n## 二、基本面主线：海外业务高增对冲国内压力，新管线拓展打开空间（长期逻辑）\n据公司披露的2025年年报及最新业务动态，公司全球化布局步伐持续加快，产品矩阵不断向细分场景延伸。\n- 2025年公司海外营收达3.6亿元，同比增长54.38%，欧洲市场DR设备累计装机量突破700台，其中意大利单国装机量近300台，产品已进入全球110多个国家和地区，海外业务成为核心增长极。\n- 公司持续拓展非医疗影像赛道，推出动物专用“液金”CT等产品，2026年3月与动物医疗影像设备头部企业达成深度战略合作，由后者出任动物专用螺旋CT全国总代，市场预期该细分赛道将逐步贡献新业绩增量。\n\n## 三、板块共振：医疗设备集采政策边际优化，行业贝塔行情带动跟涨（行情放大器）\n近期国内医疗设备领域政策预期持续修复，成为板块整体上行的核心背景。\n- 2025年公司在公立医院影像设备集采中中标量实现翻两番，市场份额提升10.23个百分点，国内公立市场基本盘进一步巩固，行业政策层面的边际改善缓解了市场对集采过度压价的担忧。\n- 医疗设备板块整体交易情绪回暖，带动万东医疗等核心影像设备标的同步反弹，个股本轮上涨更多属于板块β行情下的被动跟涨，并非独立的基本面反转行情。\n\n## 四、资金面特征：成交温和放大，融资与板块资金同步流入（短期情绪指标）\n本轮反弹过程中，万东医疗成交额较此前震荡阶段出现明显放量，市场交投活跃度显著提升。\n- 医疗器械板块整体资金净流入规模居前，个股获部分偏稳健型配置资金关注，资金交易主线集中在“国产替代+出口高增”赛道。\n- 目前龙虎榜暂无机构大额买卖异动记录，融资余额随股价反弹小幅回升，整体资金行为以波段配置为主，尚未出现趋势性主力资金大幅介入信号。\n\n## 风险提示\n1. 据2026年7月11日公司披露的半年度业绩预告，上半年归母净利润预亏超8250万元，大型设备收入确认周期长、低价集采订单集中入账拉低毛利率，业绩短期承压明显。\n2. 2025年民营医院业务收入同比下滑55%，医保支付方式改革下民营医疗资本开支收缩的影响仍未完全消除。\n3. 公司收到上交所2025年年报及2026年一季报信息披露监管问询函，涉及经销模式收入确认、库存管理等内控相关问题，后续整改落地进度仍需跟踪。\n4. 无液氦MRI等核心新产品的FDA审批进展尚未有明确时间表，市场预期存在兑现不及预期的可能。\n\n信息仅供参考，不构成投资建议。",
            //     "model": "doubaoseed2.0-lite",
            //     "report_date": "2026-07-15",
            //     "update_at": "2026-07-15 14:27:35"
            //     },
            // }
            // this.purchased = 1;
            // console.log('validateMarkdown ???')
            // if(this.validateMarkdown(data2.ai_report.content)){
            //     console.log('validateMarkdown')
            // }
            // let markdown = data2.ai_report.content;
            // console.log(markdown)
            // let parsed = this.parseMarkdown(markdown);
            // console.log('parsed',parsed)
            // this.sections = parsed.sections;
            // this.riskSection = parsed.riskSection;
            // this.overviewContent = parsed.overviewContent;

            // this.stockData = {"2026-08-06":{"open":65.55,"high":69.8,"low":64.87,"close":67.88,"volume":"2145292","amount":"14526885888","chg":"1.960","chg_pct":"2.973","hst_close":"65.920","stock_predict_trading_volume":"2525390","ma_a":"61.136","ma_b":"59.377","ma_c":"60.345","turnover":"1.081","new_chg_pct":"2.973"},"2026-08-05":{"open":59,"high":65.92,"low":58.9,"close":65.92,"volume":"2882234","amount":"18553114624","chg":"5.990","chg_pct":"9.995","hst_close":"59.930","ma_a":"58.197","ma_b":"58.805","ma_c":"60.388","turnover":"1.452","new_chg_pct":"9.995"},"2026-08-04":{"open":56.81,"high":60,"low":56.81,"close":59.93,"volume":"1679347","amount":"9861684224","chg":"4.030","chg_pct":"7.209","hst_close":"55.900","ma_a":"56.430","ma_b":"58.214","ma_c":"60.355","turnover":"0.846","new_chg_pct":"7.209"},"2026-08-03":{"open":55.53,"high":56.8,"low":54.64,"close":55.9,"volume":"948043","amount":"5277380096","chg":"-0.150","chg_pct":"-0.268","hst_close":"56.050","ma_a":"55.927","ma_b":"58.249","ma_c":"60.511","turnover":"0.478","new_chg_pct":"-0.268"},"2026-07-31":{"open":56.485,"high":56.91,"low":55.654,"close":56.05,"volume":"1481833","amount":"8432426496","chg":"2.900","chg_pct":"5.390","hst_close":"53.800","ma_a":"56.916","ma_b":"58.244","ma_c":"60.859","turnover":"0.747","new_chg_pct":"5.391"},"2026-07-30":{"open":56.346,"high":56.722,"low":52.61,"close":53.183,"volume":"1525984","amount":"8348593152","chg":"-3.950","chg_pct":"-6.840","hst_close":"57.750","ma_a":"57.618","ma_b":"58.332","ma_c":"61.255","turnover":"0.769","new_chg_pct":"-6.840"},"2026-07-29":{"open":57.414,"high":58.225,"low":55.061,"close":57.088,"volume":"1156169","amount":"6609570304","chg":"-0.330","chg_pct":"-0.568","hst_close":"58.080","ma_a":"59.413","ma_b":"59.244","ma_c":"61.760","turnover":"0.583","new_chg_pct":"-0.568"},"2026-07-28":{"open":58.205,"high":60.093,"low":57.137,"close":57.414,"volume":"1245020","amount":"7363428352","chg":"-3.470","chg_pct":"-5.638","hst_close":"61.550","ma_a":"59.998","ma_b":"59.824","ma_c":"62.366","turnover":"0.627","new_chg_pct":"-5.637"},"2026-07-27":{"open":59.193,"high":60.844,"low":58.818,"close":60.844,"volume":"815802","amount":"4963719168","chg":"1.300","chg_pct":"2.158","hst_close":"60.250","ma_a":"60.571","ma_b":"60.567","ma_c":"63.061","turnover":"0.411","new_chg_pct":"2.158"},"2026-07-24":{"open":60.35,"high":60.716,"low":59.48,"close":59.559,"volume":"1110640","amount":"6745295872","chg":"-2.630","chg_pct":"-4.183","hst_close":"62.880","ma_a":"59.573","ma_b":"60.719","ma_c":"63.459","turnover":"0.560","new_chg_pct":"-4.183"},"2026-07-23":{"open":61.279,"high":63.414,"low":60.291,"close":62.159,"volume":"1599235","amount":"10074799104","chg":"2.170","chg_pct":"3.574","hst_close":"60.710","ma_a":"59.047","ma_b":"61.314","ma_c":"63.952","turnover":"0.806","new_chg_pct":"3.574"},"2026-07-22":{"open":59.569,"high":62.258,"low":59.193,"close":60.014,"volume":"1586872","amount":"9759614976","chg":"-0.270","chg_pct":"-0.443","hst_close":"60.980","ma_a":"59.075","ma_b":"61.971","ma_c":"64.650","turnover":"0.800","new_chg_pct":"-0.443"},"2026-07-21":{"open":56.841,"high":61.19,"low":54.676,"close":60.281,"volume":"1856786","amount":"10894852096","chg":"4.480","chg_pct":"7.929","hst_close":"56.500","ma_a":"59.650","ma_b":"62.495","ma_c":"65.444","turnover":"0.936","new_chg_pct":"7.930"},"2026-07-20":{"open":58.205,"high":59.006,"low":54.409,"close":55.852,"volume":"1477885","amount":"8488592896","chg":"-1.090","chg_pct":"-1.893","hst_close":"57.590","ma_a":"60.563","ma_b":"62.772","ma_c":"66.092","turnover":"0.745","new_chg_pct":"-1.894"},"2026-07-17":{"open":61.309,"high":61.724,"low":56.168,"close":56.93,"volume":"1549043","amount":"9200842752","chg":"-5.430","chg_pct":"-8.616","hst_close":"63.020","ma_a":"61.864","ma_b":"63.473","ma_c":"67.199","turnover":"0.781","new_chg_pct":"-8.615"},"2026-07-16":{"open":61.635,"high":64.195,"low":60.755,"close":62.297,"volume":"982867","amount":"6234675200","chg":"-0.600","chg_pct":"-0.943","hst_close":"63.620","ma_a":"63.580","ma_b":"64.178","ma_c":"68.211","turnover":"0.495","new_chg_pct":"-0.943"},"2026-07-15":{"open":65.125,"high":65.233,"low":62.772,"close":62.89,"volume":"917560","amount":"5924843520","chg":"-1.980","chg_pct":"-3.018","hst_close":"65.600","ma_a":"64.868","ma_b":"64.276","ma_c":"68.687","turnover":"0.462","new_chg_pct":"-3.019"},"2026-07-14":{"open":62.179,"high":64.996,"low":61.368,"close":64.848,"volume":"1422285","amount":"9114464256","chg":"2.520","chg_pct":"3.995","hst_close":"63.080","ma_a":"65.340","ma_b":"64.907","ma_c":"69.145","turnover":"0.717","new_chg_pct":"3.995"},"2026-07-13":{"open":64.551,"high":65.401,"low":61.783,"close":62.357,"volume":"1264134","amount":"8102095872","chg":"-3.190","chg_pct":"-4.814","hst_close":"66.270","ma_a":"64.980","ma_b":"65.555","ma_c":"69.531","turnover":"0.637","new_chg_pct":"-4.813"},"2026-07-10":{"open":70.186,"high":70.186,"low":65.441,"close":65.51,"volume":"2082384","amount":"14277350400","chg":"-3.260","chg_pct":"-4.689","hst_close":"69.530","ma_a":"65.081","ma_b":"66.200","ma_c":"69.879","turnover":"1.049","new_chg_pct":"-4.689"},"2026-07-09":{"open":65.846,"high":68.861,"low":64.858,"close":68.733,"volume":"1736829","amount":"11766029312","chg":"3.520","chg_pct":"5.333","hst_close":"66.010","ma_a":"64.775","ma_b":"66.591","ma_c":"70.040","turnover":"0.875","new_chg_pct":"5.333"},"2026-07-08":{"open":64.255,"high":66.795,"low":63.582,"close":65.253,"volume":"1803771","amount":"11892709376","chg":"2.230","chg_pct":"3.496","hst_close":"63.780","ma_a":"63.685","ma_b":"67.328","ma_c":"70.119","turnover":"0.909","new_chg_pct":"3.496"},"2026-07-07":{"open":62.446,"high":63.909,"low":61.783,"close":63.049,"volume":"958989","amount":"6117003776","chg":"0.190","chg_pct":"0.299","hst_close":"63.590","ma_a":"64.474","ma_b":"68.393","ma_c":"70.551","turnover":"0.483","new_chg_pct":"0.299"},"2026-07-06":{"open":65.016,"high":65.243,"low":60.795,"close":62.861,"volume":"1231123","amount":"7815327744","chg":"-1.130","chg_pct":"-1.746","hst_close":"64.720","ma_a":"66.129","ma_b":"69.413","ma_c":"70.882","turnover":"0.620","new_chg_pct":"-1.746"},"2026-07-03":{"open":62.772,"high":65.461,"low":62.268,"close":63.978,"volume":"1301297","amount":"8461745152","chg":"0.700","chg_pct":"1.093","hst_close":"64.020","ma_a":"67.319","ma_b":"70.924","ma_c":"71.399","turnover":"0.656","new_chg_pct":"1.093"},"2026-07-02":{"open":66.686,"high":66.696,"low":62.9,"close":63.286,"volume":"1935915","amount":"12656687104","chg":"-5.980","chg_pct":"-8.543","hst_close":"70.000","ma_a":"68.407","ma_b":"72.245","ma_c":"72.083","turnover":"0.976","new_chg_pct":"-8.542"},"2026-07-01":{"open":72.163,"high":73.033,"low":68.703,"close":69.197,"volume":"1629668","amount":"11646583808","chg":"-2.150","chg_pct":"-2.980","hst_close":"72.150","ma_a":"70.971","ma_b":"73.097","ma_c":"72.925","turnover":"0.821","new_chg_pct":"-2.981"},"2026-06-30":{"open":68.762,"high":72.123,"low":68.387,"close":71.323,"volume":"1637706","amount":"11723794432","chg":"2.540","chg_pct":"3.649","hst_close":"69.610","ma_a":"72.311","ma_b":"73.384","ma_c":"73.419","turnover":"0.825","new_chg_pct":"3.649"},"2026-06-29":{"open":68.505,"high":70.641,"low":65.737,"close":68.812,"volume":"1964970","amount":"13558012928","chg":"-0.610","chg_pct":"-0.869","hst_close":"70.220","ma_a":"72.697","ma_b":"73.507","ma_c":"73.498","turnover":"0.990","new_chg_pct":"-0.869"},"2026-06-26":{"open":74.14,"high":74.14,"low":69.197,"close":69.415,"volume":"2623513","amount":"18933024768","chg":"-6.770","chg_pct":"-8.793","hst_close":"76.990","ma_a":"74.529","ma_b":"73.559","ma_c":"73.686","turnover":"1.322","new_chg_pct":"-8.793"},"2026-06-25":{"open":76.7,"high":76.809,"low":73.992,"close":76.107,"volume":"1961813","amount":"14951305216","chg":"0.210","chg_pct":"0.274","hst_close":"76.780","ma_a":"76.083","ma_b":"73.489","ma_c":"73.922","turnover":"0.989","new_chg_pct":"0.273"},"2026-06-24":{"open":72.163,"high":76.107,"low":72.163,"close":75.9,"volume":"2147290","amount":"16215753728","chg":"2.680","chg_pct":"3.617","hst_close":"74.100","ma_a":"75.223","ma_b":"72.910","ma_c":"73.580","turnover":"1.082","new_chg_pct":"3.618"},"2026-06-23":{"open":77.975,"high":77.985,"low":72.855,"close":73.25,"volume":"2416537","amount":"18313375744","chg":"-4.780","chg_pct":"-6.060","hst_close":"78.880","ma_a":"74.456","ma_b":"72.708","ma_c":"73.244","turnover":"1.218","new_chg_pct":"-6.060"},"2026-06-22":{"open":77.185,"high":78.499,"low":74.931,"close":77.975,"volume":"2989520","amount":"23317729280","chg":"0.800","chg_pct":"1.025","hst_close":"78.080","ma_a":"74.318","ma_b":"72.351","ma_c":"73.057","turnover":"1.507","new_chg_pct":"1.024"},"2026-06-18":{"open":71.174,"high":78.984,"low":71.125,"close":77.185,"volume":"4249682","amount":"33063389184","chg":"5.440","chg_pct":"7.489","hst_close":"72.640","ma_a":"72.588","ma_b":"71.874","ma_c":"72.477","turnover":"2.142","new_chg_pct":"7.490"},"2026-06-17":{"open":70.878,"high":71.995,"low":70.186,"close":71.807,"volume":"1654286","amount":"11897340928","chg":"-0.260","chg_pct":"-0.357","hst_close":"72.900","ma_a":"70.896","ma_b":"71.921","ma_c":"71.856","turnover":"0.834","new_chg_pct":"-0.357"},"2026-06-16":{"open":72.558,"high":74.13,"low":71.669,"close":72.064,"volume":"1741995","amount":"12770877440","chg":"-0.500","chg_pct":"-0.681","hst_close":"73.400","ma_a":"70.597","ma_b":"72.752","ma_c":"71.634","turnover":"0.878","new_chg_pct":"-0.681"},"2026-06-15":{"open":70.65,"high":72.558,"low":69.672,"close":72.558,"volume":"1626218","amount":"11779208192","chg":"3.270","chg_pct":"4.663","hst_close":"70.130","ma_a":"70.961","ma_b":"73.455","ma_c":"71.419","turnover":"0.819","new_chg_pct":"4.662"},"2026-06-12":{"open":71.115,"high":71.431,"low":69.197,"close":69.326,"volume":"1465028","amount":"10432761856","chg":"0.610","chg_pct":"0.877","hst_close":"69.520","ma_a":"70.384","ma_b":"73.490","ma_c":"71.201","turnover":"0.738","new_chg_pct":"0.877"},"2026-06-11":{"open":69.019,"high":70.73,"low":67.418,"close":68.723,"volume":"1484767","amount":"10344069120","chg":"-1.610","chg_pct":"-2.263","hst_close":"71.130","ma_a":"71.161","ma_b":"73.813","ma_c":"71.077","turnover":"0.748","new_chg_pct":"-2.263"},"2026-06-10":{"open":72.064,"high":72.657,"low":69.444,"close":70.314,"volume":"1464118","amount":"10529777664","chg":"-3.610","chg_pct":"-4.830","hst_close":"74.740","ma_a":"72.946","ma_b":"74.355","ma_c":"71.031","turnover":"0.738","new_chg_pct":"-4.831"},"2026-06-09":{"open":71.164,"high":74.021,"low":70.067,"close":73.883,"volume":"2025786","amount":"14788287488","chg":"4.260","chg_pct":"6.044","hst_close":"70.480","ma_a":"74.907","ma_b":"74.251","ma_c":"71.017","turnover":"1.021","new_chg_pct":"6.044"},"2026-06-08":{"open":69.187,"high":72.459,"low":68.545,"close":69.672,"volume":"1973161","amount":"14013579264","chg":"-3.580","chg_pct":"-4.834","hst_close":"74.060","ma_a":"75.949","ma_b":"73.780","ma_c":"70.506","turnover":"0.994","new_chg_pct":"-4.834"},"2026-06-05":{"open":76.611,"high":77.313,"low":72.262,"close":73.211,"volume":"2616486","amount":"19787640832","chg":"-4.490","chg_pct":"-5.716","hst_close":"78.550","ma_a":"76.596","ma_b":"73.762","ma_c":"70.277","turnover":"1.319","new_chg_pct":"-5.715"},"2026-06-04":{"open":79.083,"high":79.933,"low":76.463,"close":77.649,"volume":"2805857","amount":"22120464384","chg":"-2.500","chg_pct":"-3.085","hst_close":"81.050","ma_a":"76.465","ma_b":"73.080","ma_c":"69.744","turnover":"1.414","new_chg_pct":"-3.085"},"2026-06-03":{"open":79.033,"high":83.976,"low":77.531,"close":80.121,"volume":"3866136","amount":"31591776256","chg":"1.040","chg_pct":"1.300","hst_close":"80.010","ma_a":"75.763","ma_b":"71.790","ma_c":"69.034","turnover":"1.948","new_chg_pct":"1.300"},"2026-06-02":{"open":74.14,"high":80.18,"low":73.003,"close":79.093,"volume":"3778912","amount":"29404852224","chg":"6.260","chg_pct":"8.488","hst_close":"73.750","ma_a":"73.594","ma_b":"70.515","ma_c":"68.146","turnover":"1.904","new_chg_pct":"8.489"},"2026-06-01":{"open":74.338,"high":75.623,"low":71.362,"close":72.904,"volume":"3013251","amount":"22439241728","chg":"0.350","chg_pct":"0.477","hst_close":"73.400","ma_a":"71.611","ma_b":"69.383","ma_c":"67.299","turnover":"1.518","new_chg_pct":"0.477"},"2026-05-29":{"open":77.847,"high":78.717,"low":72.262,"close":72.558,"volume":"3593584","amount":"27385462784","chg":"-1.600","chg_pct":"-2.133","hst_close":"75.000","ma_a":"70.929","ma_b":"68.912","ma_c":"66.929","turnover":"1.811","new_chg_pct":"-2.134"},"2026-05-28":{"open":69.197,"high":75.405,"low":68.1,"close":74.14,"volume":"3616913","amount":"26437566464","chg":"4.920","chg_pct":"7.021","hst_close":"70.080","ma_a":"69.696","ma_b":"68.340","ma_c":"66.672","turnover":"1.823","new_chg_pct":"7.021"},"2026-05-27":{"open":69.098,"high":72.894,"low":68.891,"close":69.276,"volume":"2892366","amount":"20706824192","chg":"0.100","chg_pct":"0.143","hst_close":"69.980","ma_a":"67.817","ma_b":"67.708","ma_c":"66.289","turnover":"1.458","new_chg_pct":"0.142"},"2026-05-26":{"open":69.059,"high":69.988,"low":67.22,"close":69.178,"volume":"2189253","amount":"15170852864","chg":"-0.320","chg_pct":"-0.455","hst_close":"70.300","ma_a":"67.436","ma_b":"67.783","ma_c":"66.038","turnover":"1.103","new_chg_pct":"-0.455"},"2026-05-25":{"open":67.22,"high":69.692,"low":66.528,"close":69.494,"volume":"2659917","amount":"18455961600","chg":"3.140","chg_pct":"4.675","hst_close":"67.160","ma_a":"67.155","ma_b":"67.231","ma_c":"65.936","turnover":"1.340","new_chg_pct":"4.675"},"2026-05-22":{"open":65.352,"high":66.884,"low":63.76,"close":66.39,"volume":"1947455","amount":"12964388864","chg":"1.660","chg_pct":"2.534","hst_close":"65.500","ma_a":"66.894","ma_b":"66.791","ma_c":"65.768","turnover":"0.981","new_chg_pct":"2.534"},"2026-05-21":{"open":68.406,"high":68.703,"low":64.255,"close":64.749,"volume":"2096550","amount":"14161386496","chg":"-2.650","chg_pct":"-3.888","hst_close":"68.150","ma_a":"66.985","ma_b":"66.408","ma_c":"65.484","turnover":"1.057","new_chg_pct":"-3.889"},"2026-05-20":{"open":67.418,"high":67.705,"low":65.737,"close":67.369,"volume":"2102607","amount":"14152924160","chg":"-0.410","chg_pct":"-0.598","hst_close":"68.560","ma_a":"67.598","ma_b":"66.277","ma_c":"65.286","turnover":"1.060","new_chg_pct":"-0.598"},"2026-05-19":{"open":67.517,"high":68.248,"low":65.639,"close":67.774,"volume":"1914641","amount":"12976777216","chg":"-0.420","chg_pct":"-0.609","hst_close":"68.980","ma_a":"68.130","ma_b":"65.776","ma_c":"64.931","turnover":"0.965","new_chg_pct":"-0.609"},"2026-05-18":{"open":65.125,"high":69.425,"low":64.205,"close":68.189,"volume":"2518482","amount":"17163106304","chg":"1.360","chg_pct":"2.011","hst_close":"67.620","ma_a":"67.307","ma_b":"65.215","ma_c":"64.475","turnover":"1.269","new_chg_pct":"2.011"},"2026-05-15":{"open":68.703,"high":70.937,"low":66.597,"close":66.845,"volume":"3425679","amount":"23796803584","chg":"-0.980","chg_pct":"-1.429","hst_close":"68.600","ma_a":"66.689","ma_b":"64.946","ma_c":"63.923","turnover":"1.726","new_chg_pct":"-1.427"},"2026-05-14":{"open":73.151,"high":73.151,"low":66.509,"close":67.813,"volume":"4017452","amount":"28126042112","chg":"-2.240","chg_pct":"-3.162","hst_close":"70.840","ma_a":"65.830","ma_b":"65.003","ma_c":"63.493","turnover":"2.025","new_chg_pct":"-7.297"}}

            // this.stock_data = {
            //     chg_pct: 0.57,
            //     price: 3900.35,
            //     chg:22,
            // };

            // this.timeData = {"29767770":{"p":"68.270","a":"68.925","v":"3057600"},"29767771":{"p":"68.850","a":"68.989","v":"3057800"},"29767772":{"p":"68.880","a":"68.949","v":"2040800"},"29767773":{"p":"68.540","a":"68.886","v":"2190300"},"29767774":{"p":"68.380","a":"68.819","v":"2212800"},"29767775":{"p":"68.570","a":"68.746","v":"2510900"},"29767776":{"p":"68.480","a":"68.730","v":"1366600"},"29767777":{"p":"68.660","a":"68.722","v":"1274900"},"29767778":{"p":"68.220","a":"68.672","v":"2204000"},"29767779":{"p":"68.360","a":"68.640","v":"1759400"},"29767780":{"p":"68.640","a":"68.631","v":"1498500"},"29767781":{"p":"68.310","a":"68.626","v":"845300"},"29767782":{"p":"68.280","a":"68.612","v":"1043200"},"29767783":{"p":"68.140","a":"68.600","v":"1034100"},"29767784":{"p":"67.900","a":"68.556","v":"2235200"},"29767785":{"p":"67.980","a":"68.519","v":"1954000"},"29767786":{"p":"67.630","a":"68.475","v":"1949100"},"29767787":{"p":"68.020","a":"68.433","v":"2031100"},"29767788":{"p":"68.430","a":"68.428","v":"711900"},"29767789":{"p":"68.700","a":"68.438","v":"2018700"},"29767790":{"p":"68.360","a":"68.441","v":"950300"},"29767791":{"p":"68.480","a":"68.441","v":"616900"},"29767792":{"p":"68.940","a":"68.452","v":"1522700"},"29767793":{"p":"68.560","a":"68.458","v":"778600"},"29767794":{"p":"68.370","a":"68.459","v":"616600"},"29767795":{"p":"68.710","a":"68.460","v":"503400"},"29767796":{"p":"68.640","a":"68.463","v":"456700"},"29767797":{"p":"68.630","a":"68.465","v":"657000"},"29767798":{"p":"68.820","a":"68.469","v":"560800"},"29767799":{"p":"68.610","a":"68.473","v":"566400"},"29767800":{"p":"68.790","a":"68.475","v":"434800"},"29767801":{"p":"68.850","a":"68.478","v":"434000"},"29767802":{"p":"68.560","a":"68.481","v":"576300"},"29767803":{"p":"68.330","a":"68.480","v":"777000"},"29767804":{"p":"68.500","a":"68.479","v":"542300"},"29767805":{"p":"68.610","a":"68.479","v":"300800"},"29767806":{"p":"68.480","a":"68.479","v":"650300"},"29767807":{"p":"68.550","a":"68.480","v":"416300"},"29767808":{"p":"68.400","a":"68.480","v":"395700"},"29767809":{"p":"68.550","a":"68.480","v":"336900"},"29767810":{"p":"68.540","a":"68.480","v":"520700"},"29767811":{"p":"68.650","a":"68.482","v":"640400"},"29767812":{"p":"68.630","a":"68.483","v":"489600"},"29767813":{"p":"68.500","a":"68.483","v":"438400"},"29767814":{"p":"68.490","a":"68.483","v":"420700"},"29767815":{"p":"68.660","a":"68.484","v":"477400"},"29767816":{"p":"68.600","a":"68.486","v":"559100"},"29767817":{"p":"68.630","a":"68.487","v":"696400"},"29767818":{"p":"68.520","a":"68.488","v":"777200"},"29767819":{"p":"68.450","a":"68.487","v":"733400"},"29767820":{"p":"68.520","a":"68.488","v":"628000"},"29767821":{"p":"68.580","a":"68.488","v":"382600"},"29767822":{"p":"68.780","a":"68.490","v":"1130200"},"29767823":{"p":"68.720","a":"68.493","v":"575200"},"29767824":{"p":"68.660","a":"68.494","v":"408800"},"29767825":{"p":"68.880","a":"68.498","v":"770400"},"29767826":{"p":"68.750","a":"68.500","v":"410600"},"29767827":{"p":"68.630","a":"68.501","v":"385000"},"29767828":{"p":"68.750","a":"68.502","v":"268400"},"29767829":{"p":"68.730","a":"68.504","v":"458400"},"29767830":{"p":"68.820","a":"68.507","v":"538300"},"29767831":{"p":"69.060","a":"68.522","v":"2080900"},"29767832":{"p":"68.980","a":"68.530","v":"982000"},"29767833":{"p":"68.900","a":"68.534","v":"721700"},"29767834":{"p":"69.000","a":"68.537","v":"459200"},"29767835":{"p":"69.190","a":"68.548","v":"1167300"},"29767836":{"p":"69.250","a":"68.554","v":"630200"},"29767837":{"p":"69.280","a":"68.561","v":"678100"},"29767838":{"p":"69.450","a":"68.580","v":"1571800"},"29767839":{"p":"69.490","a":"68.588","v":"720700"},"29767840":{"p":"69.350","a":"68.597","v":"749600"},"29767841":{"p":"69.250","a":"68.602","v":"481600"},"29767842":{"p":"69.200","a":"68.609","v":"869900"},"29767843":{"p":"69.220","a":"68.615","v":"784300"},"29767844":{"p":"69.100","a":"68.620","v":"619100"},"29767845":{"p":"68.900","a":"68.623","v":"593900"},"29767846":{"p":"68.920","a":"68.625","v":"496900"},"29767847":{"p":"68.750","a":"68.627","v":"570700"},"29767848":{"p":"68.940","a":"68.628","v":"331100"},"29767849":{"p":"68.880","a":"68.629","v":"323300"},"29767850":{"p":"68.990","a":"68.631","v":"483500"},"29767851":{"p":"69.130","a":"68.632","v":"211900"},"29767852":{"p":"69.110","a":"68.634","v":"328600"},"29767853":{"p":"68.900","a":"68.635","v":"251900"},"29767854":{"p":"68.860","a":"68.636","v":"385400"},"29767855":{"p":"68.840","a":"68.637","v":"271500"},"29767856":{"p":"68.820","a":"68.638","v":"356400"},"29767857":{"p":"68.890","a":"68.639","v":"296500"},"29767858":{"p":"68.830","a":"68.639","v":"213600"},"29767859":{"p":"68.670","a":"68.640","v":"510800"},"29767860":{"p":"68.460","a":"68.638","v":"1141300"},"29767861":{"p":"68.300","a":"68.637","v":"665500"},"29767862":{"p":"68.310","a":"68.633","v":"854900"},"29767863":{"p":"68.250","a":"68.630","v":"618900"},"29767864":{"p":"68.450","a":"68.623","v":"1771900"},"29767865":{"p":"68.440","a":"68.623","v":"339800"},"29767866":{"p":"68.310","a":"68.622","v":"336100"},"29767867":{"p":"68.380","a":"68.621","v":"227600"},"29767868":{"p":"68.350","a":"68.620","v":"291500"},"29767869":{"p":"68.220","a":"68.617","v":"714200"},"29767870":{"p":"68.040","a":"68.613","v":"736900"},"29767871":{"p":"67.900","a":"68.600","v":"1802000"},"29767872":{"p":"67.990","a":"68.593","v":"1090900"},"29767873":{"p":"67.970","a":"68.587","v":"935800"},"29767874":{"p":"68.080","a":"68.580","v":"902900"},"29767875":{"p":"68.240","a":"68.577","v":"819300"},"29767876":{"p":"68.120","a":"68.574","v":"638000"},"29767877":{"p":"68.100","a":"68.571","v":"447900"},"29767878":{"p":"68.000","a":"68.569","v":"408400"},"29767879":{"p":"67.940","a":"68.567","v":"325600"},"29767880":{"p":"68.000","a":"68.564","v":"525900"},"29767881":{"p":"67.920","a":"68.562","v":"238700"},"29767882":{"p":"67.940","a":"68.559","v":"464600"},"29767883":{"p":"68.010","a":"68.557","v":"341400"},"29767884":{"p":"68.150","a":"68.556","v":"248400"},"29767885":{"p":"68.130","a":"68.555","v":"252900"},"29767886":{"p":"68.350","a":"68.554","v":"302200"},"29767887":{"p":"68.530","a":"68.554","v":"389900"},"29767888":{"p":"68.560","a":"68.554","v":"352800"},"29767889":{"p":"68.460","a":"68.554","v":"291200"},"29767890":{"p":"68.420","a":"68.554","v":"12200"},"29767980":{"p":"68.610","a":"68.553","v":"1016000"},"29767981":{"p":"68.590","a":"68.553","v":"553500"},"29767982":{"p":"68.630","a":"68.554","v":"464400"},"29767983":{"p":"68.700","a":"68.554","v":"475500"},"29767984":{"p":"68.560","a":"68.555","v":"462600"},"29767985":{"p":"68.580","a":"68.555","v":"344600"},"29767986":{"p":"68.610","a":"68.555","v":"400900"},"29767987":{"p":"68.440","a":"68.555","v":"433800"},"29767988":{"p":"68.300","a":"68.554","v":"387400"},"29767989":{"p":"68.320","a":"68.554","v":"350700"},"29767990":{"p":"68.440","a":"68.552","v":"569100"},"29767991":{"p":"68.570","a":"68.552","v":"408400"},"29767992":{"p":"68.460","a":"68.552","v":"449900"},"29767993":{"p":"68.320","a":"68.552","v":"362100"},"29767994":{"p":"68.260","a":"68.551","v":"346900"},"29767995":{"p":"68.240","a":"68.549","v":"642300"},"29767996":{"p":"68.210","a":"68.547","v":"522000"},"29767997":{"p":"68.360","a":"68.546","v":"589500"},"29767998":{"p":"68.320","a":"68.545","v":"266900"},"29767999":{"p":"68.180","a":"68.544","v":"372900"},"29768000":{"p":"68.210","a":"68.543","v":"354100"},"29768001":{"p":"68.310","a":"68.542","v":"322100"},"29768002":{"p":"68.310","a":"68.542","v":"284200"},"29768003":{"p":"68.190","a":"68.541","v":"326600"},"29768004":{"p":"68.350","a":"68.539","v":"549000"},"29768005":{"p":"68.440","a":"68.539","v":"312500"},"29768006":{"p":"68.420","a":"68.539","v":"473400"},"29768007":{"p":"68.420","a":"68.538","v":"433500"},"29768008":{"p":"68.430","a":"68.538","v":"329700"},"29768009":{"p":"68.540","a":"68.538","v":"506800"},"29768010":{"p":"68.490","a":"68.538","v":"336600"},"29768011":{"p":"68.440","a":"68.537","v":"316500"},"29768012":{"p":"68.370","a":"68.537","v":"286400"},"29768013":{"p":"68.380","a":"68.537","v":"285700"},"29768014":{"p":"68.390","a":"68.536","v":"243100"},"29768015":{"p":"68.310","a":"68.536","v":"423200"},"29768016":{"p":"68.310","a":"68.535","v":"249000"},"29768017":{"p":"68.300","a":"68.534","v":"517900"},"29768018":{"p":"68.290","a":"68.533","v":"432200"},"29768019":{"p":"68.290","a":"68.532","v":"309400"},"29768020":{"p":"68.400","a":"68.532","v":"432100"},"29768021":{"p":"68.450","a":"68.531","v":"368000"},"29768022":{"p":"68.500","a":"68.531","v":"558400"},"29768023":{"p":"68.450","a":"68.531","v":"288100"},"29768024":{"p":"68.600","a":"68.531","v":"691800"},"29768025":{"p":"68.610","a":"68.531","v":"586200"},"29768026":{"p":"68.600","a":"68.531","v":"397300"},"29768027":{"p":"68.570","a":"68.532","v":"287500"},"29768028":{"p":"68.550","a":"68.532","v":"233300"},"29768029":{"p":"68.540","a":"68.532","v":"254700"},"29768030":{"p":"68.560","a":"68.532","v":"292200"},"29768031":{"p":"68.490","a":"68.532","v":"326300"},"29768032":{"p":"68.350","a":"68.531","v":"268800"},"29768033":{"p":"68.280","a":"68.531","v":"254900"},"29768034":{"p":"68.270","a":"68.529","v":"759900"},"29768035":{"p":"68.260","a":"68.528","v":"339300"},"29768036":{"p":"68.280","a":"68.527","v":"452600"},"29768037":{"p":"68.270","a":"68.527","v":"180100"},"29768038":{"p":"68.110","a":"68.525","v":"697100"},"29768039":{"p":"67.960","a":"68.520","v":"1213100"},"29768040":{"p":"68.010","a":"68.517","v":"701200"},"29768041":{"p":"67.930","a":"68.515","v":"516000"},"29768042":{"p":"67.990","a":"68.513","v":"443200"},"29768043":{"p":"67.840","a":"68.508","v":"958000"},"29768044":{"p":"68.000","a":"68.505","v":"524300"},"29768045":{"p":"68.000","a":"68.504","v":"319000"},"29768046":{"p":"68.100","a":"68.503","v":"416400"},"29768047":{"p":"68.200","a":"68.501","v":"482900"},"29768048":{"p":"68.250","a":"68.500","v":"695800"},"29768049":{"p":"68.200","a":"68.499","v":"496200"},"29768050":{"p":"68.230","a":"68.498","v":"372900"},"29768051":{"p":"68.060","a":"68.497","v":"252300"},"29768052":{"p":"68.070","a":"68.496","v":"381500"},"29768053":{"p":"67.960","a":"68.494","v":"509600"},"29768054":{"p":"67.920","a":"68.493","v":"364700"},"29768055":{"p":"67.870","a":"68.489","v":"788300"},"29768056":{"p":"67.680","a":"68.481","v":"1453100"},"29768057":{"p":"67.600","a":"68.473","v":"1254500"},"29768058":{"p":"67.850","a":"68.468","v":"903600"},"29768059":{"p":"67.800","a":"68.466","v":"445600"},"29768060":{"p":"67.760","a":"68.464","v":"465300"},"29768061":{"p":"67.750","a":"68.462","v":"304500"},"29768062":{"p":"67.680","a":"68.460","v":"466100"},"29768063":{"p":"67.650","a":"68.456","v":"563800"},"29768064":{"p":"67.610","a":"68.453","v":"642300"},"29768065":{"p":"67.580","a":"68.448","v":"802500"},"29768066":{"p":"67.610","a":"68.445","v":"414700"},"29768067":{"p":"67.500","a":"68.437","v":"1299300"},"29768068":{"p":"67.610","a":"68.433","v":"603600"},"29768069":{"p":"67.700","a":"68.430","v":"568200"},"29768070":{"p":"67.860","a":"68.427","v":"625300"},"29768071":{"p":"67.870","a":"68.424","v":"614900"},"29768072":{"p":"67.930","a":"68.421","v":"854800"},"29768073":{"p":"68.040","a":"68.420","v":"418800"},"29768074":{"p":"68.110","a":"68.419","v":"369800"},"29768075":{"p":"68.070","a":"68.418","v":"447800"},"29768076":{"p":"67.950","a":"68.417","v":"261700"},"29768077":{"p":"68.040","a":"68.416","v":"512000"},"29768078":{"p":"68.000","a":"68.415","v":"354500"},"29768079":{"p":"67.960","a":"68.414","v":"286300"},"29768080":{"p":"68.020","a":"68.412","v":"620200"},"29768081":{"p":"68.060","a":"68.411","v":"342700"},"29768082":{"p":"68.130","a":"68.410","v":"791500"},"29768083":{"p":"68.110","a":"68.409","v":"468800"},"29768084":{"p":"68.130","a":"68.408","v":"359500"},"29768085":{"p":"68.130","a":"68.407","v":"547200"},"29768086":{"p":"68.130","a":"68.406","v":"649800"},"29768087":{"p":"68.120","a":"68.405","v":"459700"},"29768088":{"p":"68.120","a":"68.404","v":"511500"},"29768089":{"p":"68.080","a":"68.402","v":"981900"},"29768090":{"p":"68.080","a":"68.401","v":"781500"},"29768091":{"p":"68.230","a":"68.399","v":"1304300"},"29768092":{"p":"68.230","a":"68.398","v":"577500"},"29768093":{"p":"68.270","a":"68.397","v":"858400"},"29768094":{"p":"68.280","a":"68.397","v":"661300"},"29768095":{"p":"68.260","a":"68.396","v":"695900"},"29768096":{"p":"68.160","a":"68.395","v":"888700"},"29768097":{"p":"68.170","a":"68.395","v":"24700"},"29768098":{"p":"68.170","a":"68.395","v":"0"},"29768099":{"p":"68.180","a":"68.395","v":"0"},"29768100":{"p":"68.180","a":"68.393","v":"1781700"}}


            // this.code = 'sh601138';

            
            // this.stockDetail_s();
            // this.stockDetail_k();


        },
        methods:{
            handleRefresh() {
                this.stockDetail_fs()
            },
            switchChart(type) {
                if (this.chartType === type) return  // 相同不切换
                this.loading = true
                this.chartType = type;
                if(this.chartType == 'time'){
                    this.stockDetail_fs();
                }
                else{
                    this.stockDetail_k();
                }
                
            },
            openstock(){
                location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=${this.code}&name=${this.name}`;
            },
            async stockDetail_fs(){
                let res = await Api.getfs({
                    code:this.code,
                });
                if(res){
                    this.timeData = res;
                }
                this.loading = false
            },
            async stockDetail_k(){
                let res = await Api.getk({
                    code:this.code,
                    type:this.chartType,
                });
                if(res){
                    this.stockData = res;
                }
                this.loading = false


            },
            async stockDetail_s(){
                let _code = this.code;
                let data = await Api.getAStock({
                    list: _code,
                });
                if(data) {
                    let spl_data = data[_code].split(',')
                    this.stock_data = {
                        chg: spl_data[1],
                        chg_pct: (spl_data[2]* 1).toFixed(2),
                        price: spl_data[0],
                        y_close:spl_data[1],
                        high:spl_data[5],
                        low:spl_data[6],
                    }
                    //this.stockDetail_fs();
                }
            },


            toggleRisk() {
                this.isRiskOpen = !this.isRiskOpen
            },
            parseMarkdown(markdown) {
                const lines = markdown.split('\n')
                
                let overviewContent = ''
                let sections = []
                let riskItems = []
                let disclaimer = ''
                
                let currentSection = null
                let currentItems = []
                let currentIntro = []
                let isCollectingItems = false
                let isRiskSection = false
                let isOverview = false

                // 有效章节数字映射
                const validSectionNumbers = ['一', '二', '三', '四', '五', '六']
                const numberToIndex = { '一': 0, '二': 1, '三': 2, '四': 3, '五': 4, '六': 5 }

                const iconMap = {
                    '一': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg',
                    '二': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-basic.svg',
                    '三': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-amoled.svg',
                    '四': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-car.svg',
                    '五': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-fund.svg',
                    '六': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-plus.svg'
                }

                const processText = (text) => {
                    let content = text
                    content = content.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
                    content = content.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
                    return content
                }

                // 判断章节是否在有效范围内（一 到 六）
                const isValidSection = (num) => {
                    return validSectionNumbers.includes(num)
                }

                for (let i = 0; i < lines.length; i++) {
                    const line = lines[i].trim()
                    if (!line) continue

                    // ===== 检测风险提示标题 =====
                    const riskMatch = line.match(/^#{2,3}\s+(风险提示.*)$/)
                    if (riskMatch) {
                    if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
                        sections.push({
                        title: currentSection,
                        intro: [...currentIntro],
                        items: [...currentItems],
                        icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
                        })
                    }
                    currentSection = null
                    currentItems = []
                    currentIntro = []
                    isCollectingItems = false
                    isRiskSection = true
                    isOverview = false
                    continue
                    }

                    // ===== 检测章节标题（只识别 一 到 六） =====
                    const sectionMatch = line.match(/^##\s+([一二三四五六七八九十]+)、(.+)$/)
                    if (sectionMatch) {
                    const num = sectionMatch[1]
                    // 只处理 一 到 六 的章节，超出部分忽略
                    if (!isValidSection(num)) {
                        // 如果当前正在收集内容，先保存之前的
                        if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
                        sections.push({
                            title: currentSection,
                            intro: [...currentIntro],
                            items: [...currentItems],
                            icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
                        })
                        }
                        // 清空状态，停止收集（超出范围的章节不展示）
                        currentSection = null
                        currentItems = []
                        currentIntro = []
                        isCollectingItems = false
                        isRiskSection = false
                        isOverview = false
                        continue
                    }

                    // 保存上一个章节
                    if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
                        sections.push({
                        title: currentSection,
                        intro: [...currentIntro],
                        items: [...currentItems],
                        icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
                        })
                    }
                    currentSection = `${sectionMatch[1]}、${sectionMatch[2]}`
                    currentItems = []
                    currentIntro = []
                    isCollectingItems = true
                    isRiskSection = false
                    isOverview = false
                    continue
                    }

                    // ===== 检测免责声明 =====
                    if (line.includes('信息仅供参考')) {
                    disclaimer = line
                    continue
                    }

                    // ===== 检测概述 =====
                    if (!isOverview && !isRiskSection && !currentSection && line && !line.match(/^#/)) {
                    overviewContent = processText(line)
                    isOverview = true
                    continue
                    }

                    // ===== 处理风险部分 =====
                    if (isRiskSection) {
                    const bulletMatch = line.match(/^-\s+(.+)$/)
                    if (bulletMatch) {
                        riskItems.push(processText(bulletMatch[1]))
                        continue
                    }
                    const numMatch = line.match(/^(\d+)\.\s+(.+)$/)
                    if (numMatch) {
                        riskItems.push(processText(numMatch[2]))
                        continue
                    }
                    if (line && !line.match(/^#/)) {
                        if (riskItems.length > 0) {
                        const last = riskItems[riskItems.length - 1]
                        if (!/[。；;！?！]$/.test(last)) {
                            riskItems[riskItems.length - 1] = last + ' ' + processText(line)
                            continue
                        }
                        }
                        riskItems.push(processText(line))
                    }
                    continue
                    }

                    // ===== 处理章节内容 =====
                    if (isCollectingItems && currentSection) {
                    const bulletMatch = line.match(/^-\s+(.+)$/)
                    if (bulletMatch) {
                        currentItems.push(processText(bulletMatch[1]))
                        continue
                    }
                    const numMatch = line.match(/^(\d+)\.\s+(.+)$/)
                    if (numMatch) {
                        currentItems.push(processText(numMatch[2]))
                        continue
                    }
                    // ===== 纯文本段落：加入 intro 数组 =====
                    if (line && !line.match(/^#/) && !line.match(/^-\s+/) && !line.match(/^\d+\.\s+/)) {
                        const processed = processText(line)
                        if (currentItems.length === 0) {
                        currentIntro.push(processed)
                        } else {
                        const last = currentItems[currentItems.length - 1]
                        if (!/[。；;！?！]$/.test(last)) {
                            currentItems[currentItems.length - 1] = last + ' ' + processed
                        }
                        }
                    }
                    }
                }

                // ===== 保存最后一个章节 =====
                if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
                    sections.push({
                    title: currentSection,
                    intro: [...currentIntro],
                    items: [...currentItems],
                    icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
                    })
                }

                return {
                    overviewContent,
                    sections,
                    riskSection: riskItems.length > 0 ? { title: '风险提示', items: riskItems } : null,
                    disclaimer
                }
            },
            validateMarkdown(markdown) {
                // 1. 必须有一级标题
                const hasTitle = /^#\s+.+/m.test(markdown)
                
                // 2. 必须有至少一个章节标题（## 一、 到 ## 六、）
                const hasSection = /^##\s+[一二三四五六]+、.+$/m.test(markdown)
                
                // 3. 必须有风险提示
                const hasRisk = /^#{2,3}\s+风险提示/m.test(markdown)

                return hasTitle && hasSection && hasRisk;
            },
            expand(){
                this.longhu_expand = !this.longhu_expand;
            },
            parseF(val){
                val = (parseFloat(val) * 100).toFixed(2);
                if(val > 0) val = '+'+val;
                return val;
            },
            async stockDetail(opt){
                let res = await Api.stockDetail(opt);
                console.log(res)
                if(res.code == 1001) {
                    //暂无此诊股
                    this.purchased = 2;
                }
                else if(res.code == 1002 || res.code == 1003 || ( res.code == 1004 && (this.is_from_agq || this.is_from_kd || this.is_from_zf) ) ){
                    //购买的产品已过期，请重新购买 or请先购买产品
                    this.purchased = 0;
                }
                else if(res.code == 0){
                    this.purchased = 1;

                    let data = res.data;
                    this.code = data.code;
                    let synthesis = data.synthesis;
                    let short = data.short;
                    let institutions = data.institutions;
                    this.insGradeResult = institutions.insGradeResult;
                    this.insHoldRatio = institutions.insHoldRatio;
                    this.insTargetPrice = institutions.insTargetPrice;
                    this.overview = synthesis.overview;
                    this.quality = synthesis.quality;
                    //this.risk = synthesis.risk;  ---没用上
                    this.strategy = synthesis.strategy;
                    this.update_time = synthesis.update_time;
                    this.dragonTiger = short.dragonTiger;
                    this.finSecGraph = short.finSecGraph;
                    this.moneyGraph = short.moneyGraph;
                    this.techAspect = short.techAspect;

                    if(data.ai_report && data.ai_report.content && this.validateMarkdown(data.ai_report.content)){
                        this.has_ai_report = true;
                        let markdown = data.ai_report.content;
                        let parsed = this.parseMarkdown(markdown);
                        console.log('parsed-validateMarkdown',parsed)
                        this.sections = parsed.sections;
                        this.riskSection = parsed.riskSection;
                        this.overviewContent = parsed.overviewContent;

                        this.stockDetail_s();
                        this.stockDetail_k();
                    }
                    else{
                        this.has_ai_report = false;
                    }


                    console.log('znzg',data.znzg)
                    if(data.znzg.message == "success"){
                        this.znzg_in = true;
                        let _data = data.znzg.data;
                        this.changeAreaTheme = _data.changeAreaTheme;
                        this.industryInfo = _data.industryInfo;
                        this.industryComment = _data.industryComment;
                        this.themeComment = _data.themeComment;
                    }



                    if(this.insGradeResult.comment.indexOf("以增持为主")>-1){
                        this.price_left = 75;
                    }else if(this.insGradeResult.comment.indexOf("以买入为主")>-1){
                        this.price_left = 85;
                    }else if(this.insGradeResult.comment.indexOf("以卖出为主")>-1){
                        this.price_left = 15;
                    }else if(this.insGradeResult.comment.indexOf("以减持为主")>-1){
                        this.price_left = 30;
                    } else if(this.insGradeResult.comment.indexOf("以中性为主")>-1){
                        this.price_left = 48;
                    }

                    this.mainCapital1 = this.moneyGraph.mainCapital;

                    this.finance_comment = data.finance_comment;
                    if(this.finance_comment.highlight) this.highlight = this.finance_comment.highlight.split('\n');
                    if(this.finance_comment.risk) this.risk = this.finance_comment.risk.split('\n');
                    if(!this.insTargetPrice.pct){
                        this.$nextTick(()=> {
                            console.log(this.$refs.chart)
                            let chart_h = this.$refs.chart.offsetHeight;
                            this.avg_top = chart_h + 'px';
                            this.cur_top = 0;
                        })
                    }
                    else {
                        this.$nextTick(()=>{
                            console.log(this.$refs.chart)
                            let chart_h = this.$refs.chart.offsetHeight;
                            let chartsqure_h = this.$refs.chartsqure.offsetHeight;
                            let price = this.insTargetPrice;
                            let range,real_h,avg_h;
                            if(price.ceil == "最高目标价"){
                                if(price.cur - price.avg > 0){
                                    range = price.max - price.min;
                                    real_h = (price.max - price.cur) / range * chart_h;
                                    this.squre_height = real_h -1 +'px';
                                    this.squre_top = 0 +'px';
                                    this.cur_top = real_h  + 'px';
                                    avg_h = (price.max - price.avg) / range * chart_h;
                                    if(avg_h - real_h < chartsqure_h){
                                        avg_h = real_h + chartsqure_h;
                                    }
                                    this.avg_top = avg_h +'px';
                                }

                            }
                            else if(price.ceil == "平均目标价"){

                                if(price.min - price.cur > 0){
                                    range = price.max - price.cur;
                                    real_h = (price.avg - price.cur) / range * chart_h;
                                    avg_h = (price.max - price.avg) / range * chart_h;
                                    let min_h = (price.min - price.cur) / range * chart_h;
                                    if(real_h < chartsqure_h){
                                        real_h = chartsqure_h;
                                    }
                                    this.avg_top = avg_h +'px';
                                    this.squre_height = real_h -1  +'px';
                                    this.squre_top = avg_h + 1 +'px';
                                    this.cur_top = chart_h + 'px';
                                    this.min_bottom = min_h + 'px';
                                }
                                else{
                                    console.log(0)
                                    range = price.max - price.min;
                                    real_h = (price.avg - price.cur) / range * chart_h;
                                    avg_h = (price.max - price.avg) / range * chart_h;
                                    if(real_h < chartsqure_h){
                                        real_h = chartsqure_h;
                                    }
                                    this.avg_top = avg_h +'px';
                                    this.squre_height = real_h -1 +'px';
                                    this.squre_top = avg_h + 1 +'px';
                                    this.cur_top = real_h + avg_h + 'px';
                                }
                            }


                        })

                    }
                }
                else {
                    //其他报错 也显示无诊股
                    this.purchased = 2;
                }

            },
            funToApp(funName, opt) {
                var u = navigator.userAgent,
                    app = navigator.appVersion;
                var data = null;
                var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    if (window.android) {
                        console.log("安卓APP---" + funName, ...opt);
                        data = window.android[funName] && window.android[funName](...opt);
                    }
                } else if (isiOS) {
                    console.log("IOS---" + funName, [...opt]);
                    // data = window[funName] && window[funName](...opt);
                    data = window.webkit && window.webkit.messageHandlers[funName].postMessage([...opt])
                }
                return data;
            }
            

        },
        computed: {
        riskListStyle() {
            return this.isRiskOpen 
                ? { height: 'auto', opacity: 1 } 
                : { height: 0, opacity: 0, overflow: 'hidden' }
            }
    },
    }
</script>

<style lang="scss">
/* 不加 scoped，让变量真正全局生效 */
:root {
  color-scheme: light;
  --page-bg: #f7f5f6;
  --card-bg: #ffffff;
  --card-shadow: 0 2px 6px rgba(90, 30, 30, 0.06);
  --text: #333333;
  --muted: #9aa3b2;
  --link: #1d88d0;
  --topic: #1d88d0;
  --icon-bg: #fdecec;
  --icon: #ff8a8a;
  --highlight: #fff3a8;
  --risk-bg: #fffaf4;
  --risk-icon-bg: #feedc5;
  --risk-text: #8a4b0a;
  --risk-line: rgba(235, 162, 81, 0.18);
}
</style>
<style lang="scss" scoped>
    * {
      box-sizing: border-box;
    }

    html {
      min-height: 100%;
      background: #eeeeee;
    }

    body {
      margin: 0;
      min-height: 100vh;
      display: flex;
      justify-content: center;
      color: var(--text);
      background: #eeeeee;
      font-family: "Noto Sans SC", -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Segoe UI", sans-serif;
      letter-spacing: 0;
    }


</style>
<style lang="scss" >

.phone_znzg::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 0;
    width: min(100vw, 375px);
    height: 260px;
    transform: translateX(-50%);
    pointer-events: none;
    background: linear-gradient(180deg, #fde5e5 0, rgba(253, 229, 229, 0) 240px);
}


.phone_znzg {
    width: min(100vw, 375px);
    position: relative;
    isolation: isolate;
    background: var(--page-bg);
    padding: 12px 12px;
}
@media (max-width: 360px) {
    .phone_znzg {
    padding-left: 10px;
    padding-right: 10px;
    }
}

.phone_znzg{
    .section-stack {
      position: relative;
      z-index: 1;
      display: grid;
      gap: 8px;
    }

    .stock-tools {
      display: grid;
      gap: 8px;
      padding: 10px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.84);
      box-shadow: var(--card-shadow);
    }

    .search-box {
      height: 40px;
      display: grid;
      grid-template-columns: 18px minmax(0, 1fr);
      align-items: center;
      gap: 8px;
      padding: 0 10px;
      border: 1px solid rgba(235, 235, 235, 0.92);
      border-radius: 10px;
      background: #ffffff;
      color: var(--muted);
      font-size: 14px;
    }

    .search-box input {
      width: 100%;
      border: 0;
      outline: 0;
      background: transparent;
      color: var(--text);
      font: inherit;
      min-width: 0;
    }

    .search-box input::placeholder {
      color: #a7afbb;
    }

    .switch-row {
      display: grid;
      grid-template-columns: 36px minmax(0, 1fr) 36px;
      gap: 8px;
      align-items: center;
    }

    .switch-button {
      width: 36px;
      height: 34px;
      border: 0;
      border-radius: 9px;
      background: #ffffff;
      color: #7d8794;
      font-size: 24px;
      line-height: 1;
      box-shadow: inset 0 0 0 1px rgba(235, 235, 235, 0.94);
    }

    .stock-count {
      min-width: 0;
      color: #727b88;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .stock-strip {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: minmax(106px, 128px);
      gap: 8px;
      overflow-x: auto;
      padding-bottom: 2px;
      scrollbar-width: none;
    }

    .stock-strip::-webkit-scrollbar {
      display: none;
    }

    .stock-option {
      min-height: 54px;
      border: 0;
      border-radius: 10px;
      background: #ffffff;
      box-shadow: inset 0 0 0 1px rgba(235, 235, 235, 0.94);
      padding: 8px 10px;
      color: var(--text);
      text-align: left;
    }

    .stock-option.active {
      background: #fff4f4;
      box-shadow: inset 0 0 0 1px rgba(255, 132, 132, 0.42);
    }

    .stock-option strong {
      display: block;
      font-size: 14px;
      line-height: 1.25;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .stock-option span {
      display: block;
      margin-top: 4px;
      color: var(--muted);
      font-size: 11px;
      line-height: 1.2;
      text-transform: uppercase;
    }

    .empty {
      padding: 18px 12px;
      color: var(--muted);
      text-align: center;
      font-size: 13px;
    }

    .overview_k{
        position: relative;
        margin-bottom: 10px;
    }

    .overview,
    .logic-card,
    .risk-card {
      width: 100%;
      border-radius: 12px;
      box-shadow: var(--card-shadow);
    }

    .overview {
      display: grid;
      gap: 8px;
      padding: 12px;
      background: var(--card-bg);
    }

    .overview_kh{
        .overview_kh1,.overview_kh2{
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 700;
            font-size: 16px;
            line-height: 100%;
            color: #333333;
            margin-bottom: 10px;

            .red{
                color: #CB382D;
            }

            .green{
                color: #659957;
            }
        }
        .overview_kh2{
            font-weight: 400;
            font-size: 13px;
            color: #939393;
            margin-bottom: 5px;
        }
    }

    .chart-wrapper{
        position: relative;
        .loading-overlay{
            display: flex;
            width: 15px;
            height: 15px;
            position: absolute;
            left: 50%;
            top:50%;
            transform: translate(-50%,-50%);
        }
    }
    .chart-tabs{

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 5px;
        height: 32px;
        background: #F5F6F7;
        border-radius: 8px;


        .tab-btn{
            font-size: 13px;
            display: flex;
            align-items: center;
            text-align: center;
            color:#636363;
            border: none;
            height: 22px;
            padding: 0 20px;
            background: unset;
        }

        .active{
            /* 分时 */

            background: #fff;
            font-weight: 600;
            color: #333333;
            border-radius: 8px;


        }
    }

    .overview h2 {
      margin: 0;
      font-size: 15px;
      line-height: 1.6;
      font-weight: 800;
    }

    .overview p {
      margin: 0;
      font-size: 14px;
      line-height: 1.6;
      font-weight: 400;
      word-break: break-word;
    }

    .overview a,
    .blue {
      color: var(--link);
      text-decoration: none;
    }

    .overview strong {
      color: var(--text);
      font-weight: 800;
    }

    .topic {
      color: var(--text);
      font-weight: 700;
    }

    .logic-card,
    .risk-card {
      overflow: hidden;
      background: var(--card-bg);
    }

    details {
      display: block;
    }

    summary {
      min-height: 64px;
      display: grid;
      grid-template-columns: 30px minmax(0, 1fr) 22px;
      gap: 12px;
      align-items: center;
      padding: 12px;
      list-style: none;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
    }

    summary::-webkit-details-marker {
      display: none;
    }

    .icon {
      width: 30px;
      height: 30px;
      display: grid;
      place-items: center;
      align-self: center;
      border-radius: 9px;
      background: var(--icon-bg);
      color: var(--icon);
    }

    .icon img {
      width: 20px;
      height: 20px;
      display: block;
    }

    .summary-title {
      margin: 0;
      min-width: 0;
      color: var(--text);
      font-size: 15px;
      line-height: 1.6;
      font-weight: 800;
      word-break: break-word;
    }

    .chevron {
      width: 9px;
      height: 9px;
      justify-self: center;
      border-right: 2px solid var(--muted);
      border-bottom: 2px solid var(--muted);
      transform: rotate(45deg);
      transition: transform 220ms ease;
    }

    details[open] .chevron {
      transform: rotate(225deg);
    }

    details.closing .chevron {
      transform: rotate(45deg);
    }

    .logic-body {
      padding: 0 12px 12px;
      font-size: 14px;
      line-height: 1.6;
      color: var(--text);
      word-break: break-word;
      overflow: hidden;
      transition: height 240ms ease, opacity 200ms ease;
      will-change: height, opacity;
    }

    .logic-body p {
      margin: 0 0 8px;
    }

    .logic-body p:last-child {
      margin-bottom: 0;
    }

    .numbered-item,
    .bullet-item {
      display: grid;
      gap: 6px;
      align-items: start;
    }

    .numbered-item {
      grid-template-columns: auto minmax(0, 1fr);
    }

    .bullet-item {
      grid-template-columns: 10px minmax(0, 1fr);
      padding-left: 16px;
    }

    .item-marker {
      font-weight: 400;
      white-space: nowrap;
    }

    .bullet-dot {
      width: 5px;
      height: 5px;
      margin-top: 11px;
      border-radius: 50%;
      background: var(--text);
    }

    .item-copy {
      min-width: 0;
    }

    .logic-body ul {
      display: grid;
      gap: 8px;
      margin: 0 0 8px;
      padding-left: 18px;
    }

    .logic-body li {
      margin: 0;
    }

    .logic-body strong {
      color: var(--text);
      font-weight: 800;
    }

    .overview .text-link,
    .logic-body .text-link,
    .risk-list .text-link {
      color: var(--link);
      text-decoration: none;
      font-weight: inherit;
    }

    .key {
      font-weight: 800;
    }

    .risk-card {
      display: grid;
      gap: 12px;
      padding: 12px;
      background:
        linear-gradient(90deg, var(--risk-bg), var(--risk-bg)),
        linear-gradient(90deg, #fff3e0, #fff7ed),
        #ffffff;
    }

    .risk-head {
      width: 100%;
      border: 0;
      display: grid;
      grid-template-columns: 30px minmax(0, 1fr) 22px;
      gap: 12px;
      align-items: center;
      padding: 0;
      background: transparent;
      color: inherit;
      text-align: left;
      cursor: pointer;
      font: inherit;
      -webkit-tap-highlight-color: transparent;
    }

    .risk-head .icon {
      background: var(--risk-icon-bg);
      color: #ffb84c;
    }

    .risk-head h3 {
      margin: 0;
      font-size: 15px;
      line-height: 1.6;
      font-weight: 800;
    }

    .risk-card.open .risk-head .chevron {
      transform: rotate(225deg);
    }

    .risk-list {
      display: grid;
      gap: 8px;
      overflow: hidden;
      transition: height 240ms ease, opacity 200ms ease;
      will-change: height, opacity;
    }

    @media (prefers-reduced-motion: reduce) {
      .chevron,
      .logic-body,
      .risk-list {
        transition: none;
      }
    }

    .risk-item {
      margin: 0;
      color: var(--risk-text);
      font-size: 13px;
      line-height: 1.5;
      word-break: break-word;
    }

    .risk-divider {
      height: 1px;
      background: repeating-linear-gradient(90deg, var(--risk-line) 0 3px, transparent 3px 6px);
    }

    @media (max-width: 360px) {

      summary,
      .risk-head {
        grid-template-columns: 28px minmax(0, 1fr) 20px;
        gap: 10px;
      }

      .icon {
        width: 28px;
        height: 28px;
      }

      .stock-strip {
        grid-auto-columns: minmax(100px, 120px);
      }
    }

}
    
</style>
<style lang="scss" scope>

    @import "~@/assets/sass/global.scss";

    /* 未购买时*/
    .not_purchased{
        width: 100vw;
        min-height: 100vh;
        position: absolute;
        left: 0;
        top: 0;
        background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/znzg_bg.png) 0 0;
        background-size: 100%;
        transform-origin: center center;
        .not_purchased_box{
            text-align: center;
            width: rem(673px);
            min-height: rem(455px);
            background: rgba(255, 255, 255, 0.96);
            box-shadow: 0px rem(2px) rem(14px) 0px rgba(181, 181, 181, 0.5);
            border-radius: rem(20px);
            position: absolute;
            bottom: rem(92px);
            left: 50%;
            transform: translateX(-50%);
            z-index: 20;
            .not_name{
                height: rem(42px);
                font-size: rem(30px);
                font-weight: 400;
                color: #000000;
                line-height: rem(48px);
                padding-top: rem(25px);
            }
            .not_situation{
                height: rem(30px); //42原是
                font-size: rem(26px);
                font-weight: 400;
                color: #FE484A;
                line-height: rem(30px);
            }
            .not_trait{
                display: flex;
                justify-content: space-around;
                margin: rem(24px) 0 rem(44px);
                align-items: flex-end;
                .not_trait_img{
                    margin-bottom: rem(22px);
                    .img_one{
                        width: rem(44px);
                    }
                    .img_two{
                        width: rem(55px);
                    }
                    .img_three{
                        width: rem(50px);
                    }
                }
            }
            .not_trait_word{
                height: rem(28px);
                font-size: rem(20px);
                font-weight: 400;
                color: #333333;
                line-height: rem(29px);
            }
            .not_btn{
                padding: 0 rem(47px);
                height: rem(92px);
                background: #FE484A;
                box-shadow: 0px rem(4px) rem(11px) 0px rgba(231, 69, 69, 0.5);
                border-radius: rem(53px);
                text-align: center;
                font-size: rem(30px);
                font-weight: 400;
                color: #FFFFFF;
                line-height: rem(92px);
                margin: 0 auto;
                display: inline-block;
            }
            >p{
                margin-top: rem(20px);
                height: rem(30px);
                font-size: rem(22px);
                font-weight: 400;
                color: #636363;
                line-height: rem(30px);
                text-align: center;
            }
            .agq{

                font-size: rem(26px);
                font-weight: 400;
                color: #636363;
                line-height: rem(37px);
                padding-bottom: rem(30px);
                >a{
                    padding-left: rem(35px);
                    color: #1D88D0;
                    background: url(../../assets/images/znzg/agq.png) 0 center no-repeat;
                    background-size: rem(28px);
                }
            }
        }
    }



    /*购买之后*/
    .data_update{
        padding-left: rem(28px);
        // width: 100vw;
        height: rem(53px);
        background: #FFF7F1;
        font-size: rem(24px);
        font-weight: 400;
        color: #F68532;
        line-height: rem(53px);
    }
    .data_box{
        border-top: rem(12px) solid #F5F6F7;
        padding: 0 rem(28px);
        background-color: #ffffff;
        .goodness{
            padding-bottom: rem(25px);
            .goodness_title{
                height: rem(42px);
                img{
                    width: rem(30px);
                    margin-right: rem(6px);
                    position: relative;
                    top: rem(6px);
                }
                span{
                    height: rem(42px);
                    font-size: rem(30px);
                    font-weight: 500;
                    color: #FE484A;
                    line-height: rem(42px);
                }
                .goodness_title_blue{
                    color: #3E89FE;
                }
            }
            .goodness_content{
                li{
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #636363;
                    line-height: rem(40px);
                    list-style: none;
                    margin-left: rem(36px);
                    position: relative;
                }
                .goodness_point{
                    width: rem(10px);
                    height: rem(10px);
                    background-color: #FE484A;
                    border-radius: 50%;
                    position: absolute;
                    left: rem(-26px);
                    top: rem(16px);
                }
                .goodness_content_blue{
                    background-color: #3E89FE;
                }
            }
        }


        .target_price{
            padding-bottom: rem(50px);
            .target_price_content{
                font-size: rem(28px);
                font-weight: 400;
                color: #636363;
                line-height: rem(40px);
                margin-bottom: rem(50px);
                .span_tag{
                    color: #FE484A;
                }

            }
            .target_price_content_none{
                margin-bottom: 0;
            }
            .target_price_chart{
                height: rem(300px);
                margin: rem(50px) rem(100px) rem(20px) rem(120px);
                position: relative;
                .target_price_chart_box{
                    width: 100%;
                    height: rem(2px);
                    position: absolute;
                    left: 0;
                    font-size: rem(22px);
                    > div:nth-child(1){
                        position: absolute;
                        left: rem(-120px);
                        //top: rem(-15px);
                        color: #939393;
                        z-index: 1;
                    }
                    > div:nth-child(2){
                        position: absolute;
                        right: rem(-100px);
                        //top: rem(-15px);
                        color: #333333;
                    }
                    > div.target_font_blue{
                        color: #3E89FE;
                    }
                    > div.target_font_red{
                        color: #FE484A;
                    }
                }
                .target_price_chart_box_red{
                    background: #FE484A;
                }
                .target_price_chart_box_blue{
                    background: #3E89FE;

                }

                .target_price_chart_squre{
                    position: absolute;
                    left: 0;
                    min-height: rem(32px);
                    background: #f6f9ff;
                    width: 100%;
                    .target_price_chart_squre_text{
                        font-size: rem(24px);
                        color: #f2666d;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        position: absolute;
                        left: 55%;
                    }
                    .target_price_chart_squre_tag{
                        position: absolute;
                        top: 0;
                        left: 50%;
                        height: 100%;
                        width: rem(2px);
                        background: #5e94fa;
                        > div:nth-child(1){
                            position: absolute;
                            width: rem(2px);
                            height: rem(24px);
                            top: 0;
                            left: rem(-4px);
                            -ms-transform: rotate(20deg);
                            transform: rotate(
                                            20deg
                            );
                            -webkit-transform: rotate(
                                            20deg
                            );
                            background: #5e94fa;
                        }
                        > div:nth-child(2){
                            position: absolute;
                            width: rem(2px);
                            height: rem(24px);
                            top: 0;
                            left: rem(4px);
                            -ms-transform: rotate(-20deg);
                            transform: rotate(
                                            -20deg
                            );
                            -webkit-transform: rotate(
                                            -20deg
                            );
                            background: #5e94fa;
                        }
                    }
                }
            }
            .target_price_content_chart{
                margin-bottom: rem(44px);
                .target_price_content_chart_pos_box{
                    transform: translate(-50%, 0);
                    left: 50%;
                    position: relative;
                }
                .target_price_content_chart_pos{
                    width: rem(32px);
                    height: rem(43px);
                    background: url("https://cdncos.aigupiao.com/assets/wap/img/znzg/pos.png");
                    background-size: 100%;
                    margin-bottom: rem(13px);
                    position: relative;
                    left: 80%;
                }
                .target_price_content_chart_wrap{
                    display: flex;
                    .target_price_content_chart_box{
                        width: 19.6%;
                        margin-right: rem(6px);
                        .target_price_content_chart_box_color{
                            height: rem(23px);
                            background: linear-gradient(90deg, #86E259 0%, #BFF27B 100%);
                            border-radius: rem(4px);
                        }
                        .color2{
                            background: linear-gradient(90deg, #B3ED58 0%, #DEE800 100%);
                        }
                        .color3{
                            background: linear-gradient(90deg, #FFD968 0%, #FFB04D 100%);
                        }
                        .color4{
                            background: linear-gradient(90deg, #FF9354 0%, #F87F58 100%);
                        }
                        .color5{
                            background: linear-gradient(90deg, #F66A3E 0%, #EA1B00 100%);
                        }
                        .target_price_content_chart_box_word{
                            height: rem(74px);
                            font-size: rem(22px);
                            font-weight: 400;
                            color: #939393;
                            line-height: rem(74px);
                            text-align: center;
                        }
                    }
                }
            }



            .grade_table{
                .grade_table_title{
                    width: 100%;
                    background: #F5F6F7;
                    height: rem(72px);
                    span{
                        width: 33.3%;
                        display: inline-block;
                        text-align: center;
                        font-size: rem(26px);
                        font-weight: 400;
                        color: #333333;
                        line-height: rem(72px);
                    }
                }

                ul{
                    li{
                        height: rem(85px);
                        border-bottom: 1px solid #EBEBEB;
                        span{
                            width: 33.3%;
                            display: inline-block;
                            text-align: center;
                            font-size: rem(26px);
                            font-weight: 400;
                            color: #636363;
                            line-height: rem(85px);
                        }
                        .grade_red{
                            color: #FE484A;
                        }
                        .grade_green{
                            color: #0AC890;
                        }
                        .grade_yellow{
                            color: #F68532;
                        }
                    }
                }
            }

            .technical_analysis{
                .technical_analysis_title{
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #333333;
                    line-height: rem(40px);
                    margin-bottom: rem(20px);
                    img{
                        width: rem(10px);
                        margin-right: rem(6px);
                    }
                }
                .technical_analysis_box{
                    span{
                        padding: rem(9px) rem(16px);
                        background: #FEF4F4;
                        border-radius: 4px;
                        font-size: 26px;
                        font-weight: 400;
                        color: #FE484A;
                        line-height: rem(55px);
                        display: inline-block;
                        margin: rem(10px);
                    }
                    .down_span{
                        background: #E3F6F2;
                        color: #09BF99;
                    }
                    .hold_span{
                        background: #FFEEE1;
                        color: #DB8E5B
                    }
                }
            }

            .longhu{
                margin-bottom: rem(30px);
            }
            .longhu_box{

                .longhu_range{
                    display: flex;
                    height: rem(80px);
                    border-bottom: rem(1px) solid #EBEBEB;
                    border-top: rem(1px) solid #EBEBEB;
                    line-height: rem(80px);
                    justify-content: space-between;
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #636363;
                    align-items: center;
                    margin-bottom: rem(17px);
                    img{
                        width: rem(26px);
                        margin-right: rem(10px);
                    }
                    .longhu_rise_red{
                        margin-left: rem(15px);
                        color: #FE484A;
                    }
                    .longhu_rise_green{
                        margin-left: rem(15px);
                        color: #0AC890;
                    }
                }


                .longhu_total{
                    display: flex;
                    margin-bottom: rem(30px);
                    > div{
                        width: 33.3%;
                        text-align: center;
                        font-size: rem(28px);
                        font-weight: 400;
                        color: #636363;

                        >p{
                            line-height: rem(60px);
                        }
                        .total_num{
                            font-size: rem(34px);
                            font-weight: 400;
                            color: #FE484A;
                            line-height: rem(48px);
                        }
                        .total_num_sell{
                            color: #448DFE;
                        }
                        .total_num_net{
                            color: #333333;
                        }
                    }
                }

                .longhu_reason{
                    padding: rem(16px);
                    background: #FFF7F1;
                    border-radius: 4px;
                    font-size: rem(26px);
                    font-weight: 400;
                    color: #F68532;
                    line-height: rem(37px);
                    margin-bottom: rem(40px);
                }
                .expand{
                    width: rem(85px);
                    margin: rem(35px) auto 0;
                    font-size: rem(24px);
                    font-weight: 400;
                    color: #939393;
                    line-height: rem(33px);
                    img{
                        width: rem(26px);
                        margin-right: rem(9px);
                    }
                }
                .longhu_table{
                    .longhu_table_title{
                        padding: 0 rem(16px);
                        display: flex;
                        height: rem(72px);
                        background: #F5F6F7;
                        font-size: rem(26px);
                        font-weight: 400;
                        color: #333333;
                        line-height: rem(72px);
                        div{
                            flex: 1;
                        }
                        .longhu_table_buy5{
                            flex: unset;
                            margin-right: rem(40px);
                        }
                    }
                    .longhu_table_sell{
                        text-align: right;
                    }
                    .longhu_table_buy5{
                        width: rem(344px);
                    }
                    ul{
                        padding: 0 rem(16px);
                        font-size: rem(26px);
                        font-weight: 400;
                        color: #636363;
                        line-height: rem(37px);
                        li{
                            display: flex;
                            height: rem(114px);
                            align-items: center;
                            border-bottom: rem(1px) solid #EBEBEB;
                            div{
                                flex: 1;
                            }
                            .longhu_table_buy5{
                                flex: unset;
                                margin-right: rem(40px);
                            }
                        }
                    }
                    .longhu_green{
                        color: #09BF99;
                    }
                    .longhu_red{
                        color: #FE484A;
                    }
                    .longhu_blue{
                        color: #448DFE;
                    }
                }


            }

        }

        .target_price_p{
            color:#333333;
            margin-bottom: 10px;
            
            >h1{
                font-weight: 500;
                font-size: 15px;
                line-height: 100%;

                >span{
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 100%;
                    margin-left: 5px;
                    color:#939393;
                }
            }

            .plate_wrap{
                display: flex;
                flex-wrap: wrap;
                margin-top: 5px;

                
                .plate_i{
                    display: flex;
                    flex-direction: column;
                    margin-top: 6px;
                    align-items: center;
                    justify-content: center;
                    background: #F2F3F5;
                    margin-right: 6px;
                    width: 106px;
                    height: 70px;
                    border-radius: 4px;
                    position: relative;
                    box-sizing: border-box;

                    >i{
                        min-width: 36px;
                        height: 15px;
                        top: -5px;
                        right: -3px;
                        position: absolute;
                        padding-right: 5px;
                        padding-left: 5px;
                        border-top-left-radius: 4px;
                        border-top-right-radius: 4px;
                        border-bottom-right-radius: 4px;
                        box-sizing: border-box;
                        background: #FF443D;
                        font-weight: 400;
                        font-size: 10px;
                        line-height: 100%;
                        text-align: center;
                        color: #fff;
                        font-style: normal;
                        z-index: 1;
                        display: flex;
                        align-items: center;
                        white-space: nowrap;

                    }
                    >h1{
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 100%;
                    }
                    >span{
                        font-weight: 500;
                        font-size: 15px;
                        line-height: 100%;
                        margin-left: 5px;
                        font-family: DINPro;
                        color: #7F8E9D;
                        margin-top: 5px;
                    }

                    &.red{
                        background: #FFF3F3;
                        >span{
                            color: #CB382D;
                        }
                    }

                    &.green{
                        background: #EFFAF3;
                        >span{
                            color: #659957;
                        }
                    }
                }

                .plate_i:nth-child(3n){
                    margin-right: 0;
                }
            }
        }

        .target_price_p2{
            color:#333333;
            background: #FAF9FE;
            border-radius: 4px;
            padding: 5px;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 20px;

            p{
                margin: 0 0 5px;
            }

            .red{
                background: #FF443D;
                padding: 1px 4px;
                color: #fff;
                margin-right: 5px;
                border-radius: 4px;
            }
        }



    }
    .company_box{
        background-color: #ffffff;
        overflow: auto;
        .grade_box{
            width: rem(694px);
            height: rem(257px);
            background: #FFFFFF;
            border-radius: rem(24px);
            margin: rem(35px) auto rem(50px);
            box-shadow: 0px rem(2px) rem(14px) 0px rgba(181, 181, 181, 0.5);
            display: flex;
            .company_chart{
                width: 56%;
            }
            .grade{
                width: 44%;
                border-left: rem(1px) solid #F1F1F1;
                text-align: center;
                .grade_name{
                    height: rem(40px);
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #636363;
                    line-height: rem(40px);
                    margin-top: rem(38px);
                }
                .grade_number{
                    height: rem(101px);
                    font-size: rem(68px);
                    font-weight: 600;
                    color: #FE484A;
                    line-height: rem(101px);
                }
                .grade_word{
                    height: rem(42px);
                    font-size: rem(24px);
                    font-weight: 400;
                    color: #939393;
                    line-height: rem(33px);
                    span{
                        font-size: rem(30px);
                        color: #F68532;
                    }
                }
            }
        }
        .company_quality{
            margin-top: rem(50px);
            margin-bottom: rem(30px);
            padding: 0 rem(24px);
            .company_quality_title{
                height: rem(45px);
                margin-bottom: rem(20px);
                display: flex;
                align-items: center;
                img{
                    width: rem(33px);
                    margin-right: rem(9px);
                }
            }
            .company_quality_content{
                ul{
                    margin-left: rem(12px);
                    border-left:  rem(2px) dashed #979797;
                    padding-left: rem(28px);
                    li{
                        font-size: rem(30px);
                        font-weight: 400;
                        color: #333333;
                        line-height: rem(42px);
                        margin-bottom: rem(20px);
                        position: relative;
                        .point{
                            width: rem(18px);
                            height: rem(18px);
                            background: #FFFFFF;
                            border-radius: 50%;
                            border: rem(3px) solid #FF3939;
                            position: absolute;
                            left: rem(-41px);
                            transform: translate(0,-50%);
                            top: 50%;
                        }
                        .point_tag{
                            color: #FE484A;
                            font-size: rem(34px);
                        }
                        .blue{
                            border: rem(3px) solid #619EFF;
                        }
                    }
                }
                .company_tag{
                    margin-left: rem(42px);
                    padding: 0 rem(15px);
                    height: rem(40px);
                    background: #FF3939;
                    border-radius: rem(4px);
                    font-size: rem(24px);
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: rem(40px);
                    text-align: center;
                    display: inline-block;
                }
                .tag_blue{
                    background: #63A0FF;
                }
            }
        }
    }

    .risk_statement{
        width: 100%;
        height: rem(100px);
        background: #F5F6F7;
        font-size: rem(24px);
        font-weight: 400;
        color: #636363;
        line-height: rem(100px);
        text-align: center;
    }


    /* 通用样式  */
    .big_title_common{
        font-size: rem(32px);
        font-weight: 600;
        color: #333333;
        line-height: rem(45px);
    }
    .big_title_margin{
        display: inline-block;
        margin: rem(30px) 0 rem(20px);
    }

    /*  图表 */
    #company_chart{
        width: rem(390px);
        height: rem(256px);
    }

    #ratio_chart{
        width: rem(700px);
        height: rem(430px);
    }
    #financing_chart{
        width: rem(700px);
        height: rem(430px);
    }
    #k_chart{
        width: rem(700px);
        height: rem(250px);
    }

    #k_chart2,#time_chart{
        width: rem(650px);
        height: rem(300px);
    }

    #k_chart3,#volume_chart {
        width: rem(650px);
        height: rem(80px);
    }



/*    html{
        touch-action: none;
    }*/
    .none{
        min-height: 100vh;
        background: #fff;
        .none_img{
            width: rem(590px);
            height: rem(448px);
            margin: rem(148px) auto rem(99px);
            img{
                width: 100%;
                height: 100%;
            }

        }
        p{
            height: rem(42px);
            font-size: rem(30px);
            color: #636363;
            line-height: rem(42px);
            text-align: center;
        }
    }

    .target_price_p2 font{
        display: inline-flex;
    }
</style>